const pagamento = [
  { value: 0, text: "Pagamento à vista" },
  { value: 1, text: "Pagamento à prazo" },
]

const formaPagamento = [
  { value: "01", text: "Dinheiro" },
  { value: "02", text: "Cheque" },
  { value: "03", text: "Cartão de Crédito" },
  { value: "04", text: "Cartão de Débito" },
  { value: "05", text: "Crédito Loja" },
  { value: "10", text: "Vale Alimentação" },
  { value: "11", text: "Vale Refeição" },
  { value: "12", text: "Vale Presente" },
  { value: "13", text: "Vale Combustível" },
  { value: "14", text: "Duplicata Mercantil" },
  { value: "15", text: "Boleto Bancário" },
  { value: "16", text: "Depósito Bancário" },
  { value: "17", text: "Pagamento Instantâneo (PIX)" },
  { value: "18", text: "Transferência bancária, Carteira Digital" },
  { value: "19", text: "Programa de fidelidade, Cashback, Crédito Virtual" },
  { value: "90", text: "Sem pagamento" },
]

const tipoArquivo = [
  { value: "Contrato" },
  { value: "Documento Fiscal" },
  { value: "Documento de Cobrança" },
  { value: "Outros" },
]

const cfop = [
  {
    text: "1101 - Compra para industrialização - Dentro do Estado.",
    value: "1101",
  },
  {
    text: "1102 - Compra para comercialização - Dentro do Estado.",
    value: "1102",
  },
  {
    text: "1113 - Compra para comercialização de mercadoria recebida anteriormente em consignação mercantil - Dentro do Estado",
    value: "1113",
  },
  {
    text: "1253 - Compra de energia elétrica por estabelecimento comercial - Dentro do Estado",
    value: "1253",
  },
  {
    text: "1303 - Aquisição de serviço de comunicação por estabelecimento comercial - Dentro do Estado",
    value: "1303",
  },
  {
    text: "1403 - Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária - Dentro do Estado.",
    value: "1403",
  },
  {
    text: "1551 - Compra de bem para o ativo imobilizado.",
    value: "1551",
  },
  {
    text: "1556 - Compras de mercadorias destinadas ao uso ou consumo.",
    value: "1556",
  },
  {
    text: "1653 - Uso e consumo de combustível.",
    value: "1653",
  },
  {
    text: "1652 - Compra de combustível ou lubrificante para comercialização.",
    value: "1652",
  },
  {
    text: "1910 - Entrada de bonificação, doação ou brinde.",
    value: "1910",
  },
  {
    text: "1917 - Entrada de mercadoria recebida em consignação mercantil ou industrial - Dentro do Estado",
    value: "1917",
  },
  {
    text: "1949 - Outra entrada de mercadoria ou prestação de serviço não especificada.",
    value: "1949",
  },
  {
    text: "2101 - Compra para industrialização - Outro Estado.",
    value: "2101",
  },
  {
    text: "2102 - Compra para comercialização - Outro Estado.",
    value: "2102",
  },
  {
    text: "2113 - Compra para comercialização de mercadoria recebida anteriormente em consignação mercantil - Fora do Estado",
    value: "2113",
  },
  {
    text: "2117 - Compra para comercialização originada de encomenda para recebimento futuro.",
    value: "2117",
  },
  {
    text: "2202 - Devolução de venda de mercadoria adquirida ou recebida de terceiros - Fora do Estado",
    value: "2202",
  },
  {
    text: "2303 - Aquisição de serviço de comunicação por estabelecimento comercial - Fora do Estado",
    value: "2303",
  },
  {
    text: "2403 - Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária - Outro Estado.",
    value: "2403",
  },
  {
    text: "2551 - Classificam-se neste código as compras de produtos destinadas ao uso ou consumo do estabelecimento - Outro Estado.",
    value: "2551",
  },
  {
    text: "2556 - Compras de produtos destinadas ao uso ou consumo do estabelecimento.",
    value: "2556",
  },
  {
    text: "2911 - Entrada de amostra grátis.",
    value: "2911",
  },
  {
    text: "2917 - Entrada de mercadoria recebida em consignação mercantil ou industrial - Fora do Estado",
    value: "2917",
  },
  {
    text: "2949 - Outra entrada de mercadoria ou prestação de serviço não especificado.",
    value: "2949",
  },
  {
    text: "2922 - lançamento efetuado a título de simples faturamento decorrente de compra para recebimento futuro",
    value: "2922",
  },
]

const defaultUserPermission = {
  vendas: {
    painelPrincipal: false,
    novoPedidoCompleto: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false,
      cancelar: false,
      permissoesEspecificas: {
        assinaturaDigital: false,
        visualizarValoresResumo: false,
      },
    },
    novoPedidoSimples: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false,
      cancelar: false,
      permissoesEspecificas: {
        visualizarValoresResumo: false,
      },
    },
    novaReceita: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false,
      cancelar: false,
      permissoesEspecificas: {
        assinaturaDigital: false,
      },
    },
    novoPDV: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false,
      permissoesEspecificas: {
        visualizarValoresResumo: false,
      },
    },
  },
  ordensDeServico: {
    painelPrincipal: false,
    novaOrdem: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    }
  },
  cadastros: {
    painelPrincipal: false,
    novoCliente: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
    novoFornecedor: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
    novoProduto: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
    novoFuncionario: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
    novoServico: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
    novoResponsavel: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
  },
  compras: {
    painelPrincipal: false,
    novaCompra: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
    notasRecebidas: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    }
  },
  financeiro: {
    painelPrincipal: false,
    novaContaReceber: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
    novaContaPagar: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    }
  },
  emissaoFiscal: {
    painelPrincipal: false,
    novaNfe: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false,
      emitir: false,
      cancelar: false,
    },
    novaNfce: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false,
      emitir: false,
      cancelar: false,
    },
    novaNfse: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false,
      emitir: false,
      cancelar: false,
    },
    novaMdfe: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false,
      emitir: false,
      cancelar: false,
    },
  },
  caixa: {
    painelPrincipal: false,
    abrirCaixa: false,
    fecharCaixa: false,
    sangria: false,
    suprimentosConta: false,
    suprimentosGaveta: false,
    transferencia: false,
    ajusteDeCaixa: false,
    ajusteDeConta: false,
    caixaAutomatico: false,
    sangriaGeral: false,
    receita: false,
    despesa: false,
    deletar: false
  },
  agenda: {
    painelPrincipal: false,
  },
  relatorios: {
    painelPrincipal: false,
    imprimir: false,
  },
  configuracoes: {
    painelPrincipal: false,
    empresa: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
    permissoes: {
      vendas: false,
      cadastros: false,
      compras: false,
      financeiro: false,
      fiscal: false,
      caixa: false,
      configOutros: false
    },
    registroPonto: {
      painelPrincipal: false,
    },
    gerenciamentoEmpresas: {
      acessar: false,
    },
    registros: {
      acessar: false,
    },
    configAdicionais: {
      acessar: false,
    },
  },
  controleEstoque: {
    movimentacaoAgrotoxicos: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
    inventario: {
      acessar: false,
      salvar: false,
      editar: false,
      ler: false,
      deletar: false
    },
  },
}

const defaultAdmPermission = {
  vendas: {
    painelPrincipal: true,
    novoPedidoCompleto: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true,
      cancelar: true,
      permissoesEspecificas: {
        assinaturaDigital: true,
        visualizarValoresResumo: true,
      },
    },
    novoPedidoSimples: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true,
      cancelar: true,
      permissoesEspecificas: {
        visualizarValoresResumo: true,
      },
    },
    novaReceita: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true,
      cancelar: true,
      permissoesEspecificas: {
        assinaturaDigital: true,
      },
    },
    novoPDV: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true,
      permissoesEspecificas: {
        visualizarValoresResumo: true,
      },
    },
  },
  ordensDeServico: {
    painelPrincipal: true,
    novaOrdem: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    }
  },
  cadastros: {
    painelPrincipal: true,
    novoCliente: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
    novoFornecedor: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
    novoProduto: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
    novoFuncionario: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
    novoServico: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
    novoResponsavel: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
  },
  compras: {
    painelPrincipal: true,
    novaCompra: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
    notasRecebidas: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    }
  },
  financeiro: {
    painelPrincipal: true,
    novaContaReceber: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
    novaContaPagar: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    }
  },
  emissaoFiscal: {
    painelPrincipal: true,
    novaNfe: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true,
      emitir: true,
      cancelar: true,
    },
    novaNfce: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true,
      emitir: true,
      cancelar: true,
    },
    novaNfse: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true,
      emitir: true,
      cancelar: true,
    },
    novaMdfe: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true,
      emitir: true,
      cancelar: true,
    },
  },
  caixa: {
    painelPrincipal: true,
    abrirCaixa: true,
    fecharCaixa: true,
    sangria: true,
    suprimentosConta: true,
    suprimentosGaveta: true,
    transferencia: true,
    ajusteDeCaixa: true,
    ajusteDeConta: true,
    caixaAutomatico: true,
    sangriaGeral: true,
    receita: true,
    despesa: true,
    deletar: true
  },
  agenda: {
    painelPrincipal: true,
  },
  relatorios: {
    painelPrincipal: true,
    imprimir: true,
  },
  configuracoes: {
    painelPrincipal: true,
    empresa: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
    permissoes: {
      vendas: true,
      cadastros: true,
      compras: true,
      financeiro: true,
      fiscal: true,
      caixa: true,
      configOutros: true
    },
    registroPonto: {
      painelPrincipal: true,
    },
    gerenciamentoEmpresas: {
      acessar: true,
    },
    registros: {
      acessar: true,
    },
    configAdicionais: {
      acessar: true,
    },
  },
  controleEstoque: {
    movimentacaoAgrotoxicos: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
    inventario: {
      acessar: true,
      salvar: true,
      editar: true,
      ler: true,
      deletar: true
    },
  },
}

const defaultWorkingSchedule = {
  domingo: {
    ativo: false,
    inicio: null,
    intervalo: null,
    fim: null,
    carga_horaria: null,
  },
  segunda: {
    ativo: false,
    inicio: null,
    intervalo: null,
    fim: null,
    carga_horaria: null,
  },
  terca: {
    ativo: false,
    inicio: null,
    intervalo: null,
    fim: null,
    carga_horaria: null,
  },
  quarta: {
    ativo: false,
    inicio: null,
    intervalo: null,
    fim: null,
    carga_horaria: null,
  },
  quinta: {
    ativo: false,
    inicio: null,
    intervalo: null,
    fim: null,
    carga_horaria: null,
  },
  sexta: {
    ativo: false,
    inicio: null,
    intervalo: null,
    fim: null,
    carga_horaria: null,
  },
  sabado: {
    ativo: false,
    inicio: null,
    intervalo: null,
    fim: null,
    carga_horaria: null,
  },
}

const ufs = [
  { text: 'AC', value: 'AC' },
  { text: 'AL', value: 'AL' },
  { text: 'AP', value: 'AP' },
  { text: 'AM', value: 'AM' },
  { text: 'BA', value: 'BA' },
  { text: 'CE', value: 'CE' },
  { text: 'DF', value: 'DF' },
  { text: 'ES', value: 'ES' },
  { text: 'GO', value: 'GO' },
  { text: 'MA', value: 'MA' },
  { text: 'MT', value: 'MT' },
  { text: 'MS', value: 'MS' },
  { text: 'MG', value: 'MG' },
  { text: 'PA', value: 'PA' },
  { text: 'PB', value: 'PB' },
  { text: 'PR', value: 'PR' },
  { text: 'PE', value: 'PE' },
  { text: 'PI', value: 'PI' },
  { text: 'RJ', value: 'RJ' },
  { text: 'RN', value: 'RN' },
  { text: 'RS', value: 'RS' },
  { text: 'RO', value: 'RO' },
  { text: 'RR', value: 'RR' },
  { text: 'SC', value: 'SC' },
  { text: 'SP', value: 'SP' },
  { text: 'SE', value: 'SE' },
  { text: 'TO', value: 'TO' }
];

const productionOrderSituations = [
  { text: 'Pendente', value: "pendente" },
  { text: 'Aprovado', value: "aprovado" },
  { text: 'Em separação', value: "em_separacao" },
  { text: 'Produção', value: "producao" },
  { text: 'Pronta Entrega', value: "pronta_entrega" },
  { text: 'Finalizado', value: "finalizado" },
  { text: 'Cancelado', value: "cancelado" },
  { text: 'Pausado', value: "pausado" },
]

const nfseSituationsNfse = [
  { text: 'Pendente', value: "Pendente" },
  { text: 'Em andamento', value: "Em andamento" },
  { text: 'Finalizado', value: "Finalizado" },
  { text: 'Faturado', value: "Faturado" },
  { text: 'Cancelado', value: "Cancelado" },
]

const typesInstallment = [
  { text: "Venda à vista", value: 1 },
  ...Array.from({ length: 47 }, (_, i) => ({
    text: `${i + 2}x`,
    value: i + 2
  }))
];

const departaments = [
  {
    text: "Recursos humanos",
    value: "recursos_humanos",
  },
  { text: "Fiscal", value: "fiscal" },
  {
    text: "Contabilidade e Imposto de Renda",
    value: "contabilidade_imposto_renda",
  },
  { text: "Auditoria", value: "auditoria" },
  {
    text: "Previdenciário e legislação",
    value: "previdenciario_legislacao",
  },
  {
    text: "Adminstrativo",
    value: "adminstrativo",
  },
  { text: "Outros", value: "outros" },
]

const resumeTypes = [
  { text: "Diários", value: "diario" },
  { text: "Semanal", value: "semanal" },
  { text: "Mensal", value: "mensal" },
]

const typesKeyPix = [
  { text: "CPF", value: 1 },
  { text: "CNPJ", value: 2 },
  { text: "E-mail", value: 3 },
  { text: "Telefone Celular", value: 4 },
  { text: "Chave aleatória", value: 5 },
]

const decimalPlacesOptions = [
  { text: "2 casas após a vírgula", value: 2 },
  { text: "3 casas após a vírgula", value: 3 },
  { text: "4 casas após a vírgula", value: 4 },
  { text: "5 casas após a vírgula", value: 5 },
]

const unidade = [
  { text: 'Ampola', value: 'AMP' },
  { text: 'Barril', value: 'BR' },
  { text: 'Cento', value: 'Cento' },
  { text: 'Caixa', value: 'CX' },
  { text: 'Centímetro (cm)', value: 'CM' },
  { text: 'Conjunto', value: 'CONJ' },
  { text: 'Dúzia', value: 'DZ' },
  { text: 'Envolope', value: 'ENV' },
  { text: 'Fardo', value: 'Fardo' },
  { text: 'Frasco', value: 'Frasco' },
  { text: 'Galão', value: 'GL' },
  { text: 'Grama (g)', value: 'GR' },
  { text: 'Jogo', value: 'JG' },
  { text: 'Kit', value: 'Kit' },
  { text: 'Litro (l)', value: 'L' },
  { text: 'Lote', value: 'Lote' },
  { text: 'Metro (m)', value: 'MT' },
  { text: 'Metro Quadrado (mt²)', value: 'MT2' },
  { text: 'Mililitro (ml)', value: 'ML' },
  { text: 'Milímetro (mm)', value: 'MM' },
  { text: 'Pacote', value: 'PCT' },
  { text: 'Palete', value: 'PBR' },
  { text: 'Par', value: 'PAR' },
  { text: 'Peça', value: 'PC' },
  { text: 'Quilograma (kg)', value: 'KG' },
  { text: 'Rolo', value: 'Rolo' },
  { text: 'Saco', value: 'Saco' },
  { text: 'Tubo', value: 'Tubo' },
  { text: 'Tonelada', value: 'TON' },
  { text: 'Unidade', value: 'UND' },
  { text: 'Balde', value: 'BD' },
];

const genero = [
  { value: '00', text: 'Serviço' },
  { value: '01', text: 'Animais vivos' },
  { value: '02', text: 'Carnes e miudezas' },
  { value: '03', text: 'Peixes e crustáceos' },
  { value: '04', text: 'Leite e laticínios; ovos' },
  { value: '05', text: 'Outros produtos de origem animal' },
  { value: '06', text: 'Plantas vivas e floricultura' },
  { value: '07', text: 'Produtos hortícolas comestíveis' },
  { value: '08', text: 'Frutas e cascas de melões' },
  { value: '09', text: 'Café, chá, mate e especiarias' },
  { value: '10', text: 'Cereais' },
  { value: '11', text: 'Produtos de moagem; amidos' },
  { value: '12', text: 'Sementes e frutos oleaginosos' },
  { value: '13', text: 'Gomas e resinas vegetais' },
  { value: '14', text: 'Matérias para entrançar e produtos vegetais' },
  { value: '15', text: 'Gorduras e óleos; ceras' },
  { value: '16', text: 'Preparações de carne, peixes e crustáceos' },
  { value: '17', text: 'Açúcares e confeitaria' },
  { value: '18', text: 'Cacau e preparações' },
  { value: '19', text: 'Preparações à base de cereais e leite' },
  { value: '20', text: 'Preparações de hortícolas e frutas' },
  { value: '21', text: 'Preparações alimentícias diversas' },
  { value: '22', text: 'Bebidas e vinagres' },
  { value: '23', text: 'Resíduos e alimentos para animais' },
  { value: '24', text: 'Fumo e sucedâneos' },
  { value: '25', text: 'Sal, enxofre, terras e pedras' },
  { value: '26', text: 'Minérios e escórias' },
  { value: '27', text: 'Combustíveis minerais e ceras minerais' },
  { value: '28', text: 'Produtos químicos inorgânicos' },
  { value: '29', text: 'Produtos químicos orgânicos' },
  { value: '30', text: 'Produtos farmacêuticos' },
  { value: '31', text: 'Adubos e fertilizantes' },
  { value: '32', text: 'Extratos e pigmentos' },
  { value: '33', text: 'Óleos essenciais e produtos de perfumaria' },
  { value: '34', text: 'Sabões e produtos de limpeza' },
  { value: '35', text: 'Matérias albuminóides e colas' },
  { value: '36', text: 'Pólvoras e explosivos' },
  { value: '37', text: 'Produtos para fotografia e cinematografia' },
  { value: '38', text: 'Produtos das indústrias químicas' },
  { value: '39', text: 'Plásticos e suas obras' },
  { value: '40', text: 'Borracha e suas obras' },
  { value: '41', text: 'Peles e couros' },
  { value: '42', text: 'Obras de couro e artigos de viagem' },
  { value: '43', text: 'Peleteria e suas obras' },
  { value: '44', text: 'Madeira e carvão vegetal' },
  { value: '45', text: 'Cortiça e suas obras' },
  { value: '46', text: 'Espartaria e cestaria' },
  { value: '47', text: 'Pastas de madeira e papel reciclado' },
  { value: '48', text: 'Papel e cartão' },
  { value: '49', text: 'Livros, jornais e produtos gráficos' },
  { value: '50', text: 'Seda' },
  { value: '51', text: 'Lã e fios de crina' },
  { value: '52', text: 'Algodão' },
  { value: '53', text: 'Outras fibras têxteis' },
  { value: '54', text: 'Filamentos sintéticos' },
  { value: '55', text: 'Fibras sintéticas descontínuas' },
  { value: '56', text: 'Pastas, feltros e cordéis' },
  { value: '57', text: 'Tapetes e revestimentos têxteis' },
  { value: '58', text: 'Tecidos especiais e bordados' },
  { value: '59', text: 'Tecidos impregnados e técnicos' },
  { value: '60', text: 'Tecidos de malha' },
  { value: '61', text: 'Vestuário de malha' },
  { value: '62', text: 'Vestuário exceto de malha' },
  { value: '63', text: 'Outros artefatos têxteis e calçados' },
  { value: '64', text: 'Calçados e suas partes' },
  { value: '65', text: 'Chapéus e suas partes' },
  { value: '66', text: 'Guarda-chuvas e bengalas' },
  { value: '67', text: 'Penas, flores artificiais e obras de cabelo' },
  { value: '68', text: 'Obras de pedra e cimento' },
  { value: '69', text: 'Produtos cerâmicos' },
  { value: '70', text: 'Vidro e suas obras' },
  { value: '71', text: 'Pérolas, pedras preciosas e bijuterias' },
  { value: '72', text: 'Ferro fundido e aço' },
  { value: '73', text: 'Obras de ferro fundido e aço' },
  { value: '74', text: 'Cobre e suas obras' },
  { value: '75', text: 'Níquel e suas obras' },
  { value: '76', text: 'Alumínio e suas obras' },
  { value: '77', text: '(Reservado para futura utilização)' },
  { value: '78', text: 'Chumbo e suas obras' },
  { value: '79', text: 'Zinco e suas obras' },
  { value: '80', text: 'Estanho e suas obras' },
  { value: '81', text: 'Outros metais comuns' },
  { value: '82', text: 'Ferramentas e cutelaria' },
  { value: '83', text: 'Obras de metais comuns' },
  { value: '84', text: 'Máquinas e aparelhos mecânicos' },
  { value: '85', text: 'Máquinas e aparelhos elétricos' },
  { value: '86', text: 'Veículos para vias férreas' },
  { value: '87', text: 'Veículos automóveis e partes' },
  { value: '88', text: 'Aeronaves e partes' },
  { value: '89', text: 'Embarcações e estruturas flutuantes' },
  { value: '90', text: 'Instrumentos de óptica e precisão' },
  { value: '91', text: 'Aparelhos de relojoaria' },
  { value: '92', text: 'Instrumentos musicais' },
  { value: '93', text: 'Armas e munições' },
  { value: '94', text: 'Móveis e iluminação' },
  { value: '95', text: 'Brinquedos e artigos de esporte' },
  { value: '96', text: 'Obras diversas' },
  { value: '97', text: 'Objetos de arte e antiguidades' },
  { value: '98', text: '(Reservado para usos especiais)' },
  { value: '99', text: 'Operações especiais (Brasil)' }
];

const TypePaymentsForCombobox = [
  { value: "01", text: "Dinheiro" },
  { value: "02", text: "Cheque" },
  { value: "03", text: "Cartão de Crédito" },
  { value: "04", text: "Cartão de Débito" },
  { value: "05", text: "Crédito Loja" },
  { value: "10", text: "Vale Alimentação" },
  { value: "11", text: "Vale Refeição" },
  { value: "12", text: "Vale Presente" },
  { value: "13", text: "Vale Combustível" },
  { value: "14", text: "Duplicata Mercantil" },
  { value: "15", text: "Boleto Bancário" },
  { value: "16", text: "Depósito Bancário" },
  { value: "17", text: "Pagamento Instantâneo (PIX)" },
  { value: "18", text: "Transferência bancária, Carteira Digital" },
  { value: "19", text: "Programa de fidelidade, Cashback, Crédito Virtual" },
  { value: "90", text: "Sem pagamento" },
]

const codesService = [
  { value: "01.01.01", text: "01.01.01 - Análise e desenvolvimento de sistemas." },
  { value: "01.02.01", text: "01.02.01 - Programação." },
  { value: "01.03.01", text: "01.03.01 - Processamento de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres." },
  { value: "01.03.02", text: "01.03.02 - Armazenamento ou hospedagem de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres." },
  { value: "01.04.01", text: "01.04.01 - Elaboração de programas de computadores, inclusive de jogos eletrônicos, independentemente da arquitetura construtiva da máquina em que o programa será executado, incluindo tablets, smartphones e congêneres" },
  { value: "01.05.01", text: "01.05.01 - Licenciamento ou cessão de direito de uso de programas de computação." },
  { value: "01.06.01", text: "01.06.01 - Assessoria e consultoria em informática." },
  { value: "01.07.01", text: "01.07.01 - Suporte técnico em informática, inclusive instalação, configuração e manutenção de programas de computação e bancos de dados." },
  { value: "01.08.01", text: "01.08.01 - Planejamento, confecção, manutenção e atualização de páginas eletrônicas." },
  { value: "01.09.01", text: "01.09.01 - Disponibilização, sem cessão definitiva, de conteúdos de áudio por meio da internet (exceto a distribuição de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS)" },
  { value: "01.09.02", text: "01.09.02 - Disponibilização, sem cessão definitiva, de conteúdos de vídeo, imagem e texto por meio da internet, respeitada a imunidade de livros, jornais e periódicos (exceto a distribuição de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS)" },
  { value: "02.01.01", text: "02.01.01 - Serviços de pesquisas e desenvolvimento de qualquer natureza" },
  { value: "03.02.01", text: "03.02.01 - Cessão de direito de uso de marcas e de sinais de propaganda" },
  { value: "03.03.01", text: "03.03.01 - Exploração de salões de festas, centro de convenções, stands e congêneres, para realização de eventos ou negócios de qualquer natureza" },
  { value: "03.03.02", text: "03.03.02 - Exploração de escritórios virtuais e congêneres, para realização de eventos ou negócios de qualquer natureza" },
  { value: "03.03.03", text: "03.03.03 - Exploração de quadras esportivas, estádios, ginásios, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza." },
  { value: "03.03.04", text: "03.03.04 - Exploração de auditórios, casas de espetáculos e congêneres, para realização de eventos ou negócios de qualquer natureza." },
  { value: "03.03.05", text: "03.03.05 - Exploração de parques de diversões e congêneres, para realização de eventos ou negócios de qualquer natureza" },
  { value: "03.04.01", text: "03.04.01 - Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia" },
  { value: "03.04.02", text: "03.04.02 - Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de rodovia" },
  { value: "03.04.03", text: "03.04.03 - Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de postes, cabos, dutos e condutos de qualquer natureza." },
  { value: "03.05.01", text: "03.05.01 - Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário" },
  { value: "04.01.01", text: "04.01.01 - Medicina." },
  { value: "04.01.02", text: "04.01.02 - Biomedicina" },
  { value: "04.02.01", text: "04.02.01 - Análises clínicas e congêneres" },
  { value: "04.02.02", text: "04.02.02 - Patologia e congêneres" },
  { value: "04.02.03", text: "04.02.03 - Eletricidade médica (eletroestimulação de nervos e musculos, cardioversão, etc) e congêneres" },
  { value: "04.02.04", text: "04.02.04 - Radioterapia, quimioterapia e congêneres" },
  { value: "04.02.05", text: "04.02.05 - Ultra-sonografia, ressonância magnética, radiologia, tomografia e congêneres" },
  { value: "04.03.01", text: "04.03.01 - Hospitais e congêneres" },
  { value: "04.03.02", text: "04.03.02 - Laboratórios e congêneres" },
  { value: "04.03.03", text: "04.03.03 - Clínicas, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres" },
  { value: "04.04.01", text: "04.04.01 - Instrumentação cirúrgica" },
  { value: "04.05.01", text: "04.05.01 - Acupuntura" },
  { value: "04.06.01", text: "04.06.01 - Enfermagem, inclusive serviços auxiliares" },
  { value: "04.07.01", text: "04.07.01 - Serviços farmacêuticos" },
  { value: "04.08.01", text: "04.08.01 - Terapia ocupacional" },
  { value: "04.08.02", text: "04.08.02 - Fisioterapia" },
  { value: "04.08.03", text: "04.08.03 - Fonoaudiologia" },
  { value: "04.09.01", text: "04.09.01 - Terapias de qualquer espécie destinadas ao tratamento físico, orgânico e mental" },
  { value: "04.10.01", text: "04.10.01 - Nutrição" },
  { value: "04.11.01", text: "04.11.01 - Obstetrícia" },
  { value: "04.12.01", text: "04.12.01 - Odontologia" },
  { value: "04.13.01", text: "04.13.01 - Ortóptica" },
  { value: "04.14.01", text: "04.14.01 - Próteses sob encomenda." },
  { value: "04.15.01", text: "04.15.01 - Psicanálise" },
  { value: "04.16.01", text: "04.16.01 - Psicologia" },
  { value: "04.17.01", text: "04.17.01 - Casas de repouso e congêneres" },
  { value: "04.17.02", text: "04.17.02 - Casas de recuperação e congêneres" },
  { value: "04.17.03", text: "04.17.03 - Creches e congêneres" },
  { value: "04.17.04", text: "04.17.04 - Asilos e congêneres" },
  { value: "04.18.01", text: "04.18.01 - Inseminação artificial, fertilização in vitro e congêneres." },
  { value: "04.19.01", text: "04.19.01 - Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres" },
  { value: "04.20.01", text: "04.20.01 - Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie." },
  { value: "04.21.01", text: "04.21.01 - Unidade de atendimento, assistência ou tratamento móvel e congêneres" },
  { value: "04.22.01", text: "04.22.01 - Planos de medicina de grupo ou individual e convênios para prestação de assistência médica, hospitalar, odontológica e congêneres" },
  { value: "04.23.01", text: "04.23.01 - Outros planos de saúde que se cumpram através de serviços de terceiros contratados, credenciados, cooperados ou apenas pagos pelo operador do plano mediante indicação do beneficiário." },
  { value: "05.01.01", text: "05.01.01 - Medicina veterinária" },
  { value: "05.01.02", text: "05.01.02 - Zootecnia" },
  { value: "05.02.01", text: "05.02.01 - Hospitais e congêneres, na área veterinária" },
  { value: "05.02.02", text: "05.02.02 - Clínicas, ambulatórios, prontos-socorros e congêneres, na área veterinária." },
  { value: "05.03.01", text: "05.03.01 - Laboratórios de análise na área veterinária" },
  { value: "05.04.01", text: "05.04.01 - Inseminação artificial, fertilização in vitro e congêneres" },
  { value: "05.05.01", text: "05.05.01 - Bancos de sangue e de órgãos e congêneres" },
  { value: "05.06.01", text: "05.06.01 - Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie" },
  { value: "05.07.01", text: "05.07.01 - Unidade de atendimento, assistência ou tratamento móvel e congêneres" },
  { value: "05.08.01", text: "05.08.01 - Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres" },
  { value: "05.09.01", text: "05.09.01 - Planos de atendimento e assistência médico-veterinária" },
  { value: "06.01.01", text: "06.01.01 - Barbearia, cabeleireiros, manicuros, pedicuros e congêneres" },
  { value: "06.02.01", text: "06.02.01 - Esteticistas, tratamento de pele, depilação e congêneres" },
  { value: "06.03.01", text: "06.03.01 - Banhos, duchas, sauna, massagens e congêneres" },
  { value: "06.04.01", text: "06.04.01 - Ginástica, dança, esportes, natação, artes marciais e demais atividades físicas" },
  { value: "06.05.01", text: "06.05.01 - Centros de emagrecimento, spa e congêneres" },
  { value: "06.06.01", text: "06.06.01 - Aplicação de tatuagens, piercings e congêneres" },
  { value: "07.01.01", text: "07.01.01 - Engenharia e congêneres" },
  { value: "07.01.02", text: "07.01.02 - Agronomia e congêneres" },
  { value: "07.01.03", text: "07.01.03 - Agrimensura e congêneres" },
  { value: "07.01.04", text: "07.01.04 - Arquitetura, urbanismo e congêneres" },
  { value: "07.01.05", text: "07.01.05 - Geologia e congêneres" },
  { value: "07.01.06", text: "07.01.06 - Paisagismo e congêneres" },
  { value: "07.02.01", text: "07.02.01 - Execução, por administração, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)" },
  { value: "07.02.02", text: "07.02.02 - Execução, por empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)." },
  { value: "07.03.01", text: "07.03.01 - Elaboração de planos diretores, estudos de viabilidade, estudos organizacionais e outros, relacionados com obras e serviços de engenharia" },
  { value: "07.03.02", text: "07.03.02 - Elaboração de anteprojetos, projetos básicos e projetos executivos para trabalhos de engenharia." },
  { value: "07.04.01", text: "07.04.01 - Demolição" },
  { value: "07.05.01", text: "07.05.01 - Reparação, conservação e reforma de edifícios e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)" },
  { value: "07.05.02", text: "07.05.02 - Reparação, conservação e reforma de estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)" },
  { value: "07.06.01", text: "07.06.01 - Colocação e instalação de tapetes, carpetes, cortinas e congêneres, com material fornecido pelo tomador do serviço." },
  { value: "07.06.02", text: "07.06.02 - Colocação e instalação de assoalhos, revestimentos de parede, vidros, divisórias, placas de gesso e congêneres, com material fornecido pelo tomador do serviço" },
  { value: "07.07.01", text: "07.07.01 - Recuperação, raspagem, polimento e lustração de pisos e congêneres." },
  { value: "07.08.01", text: "07.08.01 - Calafetação" },
  { value: "07.09.01", text: "07.09.01 - Varrição, coleta e remoção de lixo, rejeitos e outros resíduos quaisquer" },
  { value: "07.09.02", text: "07.09.02 - Incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer" },
  { value: "07.10.01", text: "07.10.01 - Limpeza, manutenção e conservação de vias e logradouros públicos, parques, jardins e congêneres" },
  { value: "07.10.02", text: "07.10.02 - Limpeza, manutenção e conservação de imóveis, chaminés, piscinas e congêneres" },
  { value: "07.11.01", text: "07.11.01 - Decoração" },
  { value: "07.11.02", text: "07.11.02 - Jardinagem, inclusive corte e poda de árvores" },
  { value: "07.12.01", text: "07.12.01 - Controle e tratamento de efluentes de qualquer natureza e de agentes físicos, químicos e biológicos" },
  { value: "07.13.01", text: "07.13.01 - Dedetização, desinfecção, desinsetização, imunização, higienização, desratização, pulverização e congêneres" },
  { value: "07.16.01", text: "07.16.01 - Florestamento, reflorestamento, semeadura, adubação, reparação de solo, plantio, silagem, colheita, corte e descascamento de árvores, silvicultura, exploração florestal e dos serviços congêneres indissociáveis da formação, manutenção e colheita de florestas, para quaisquer fins e por quaisquer meios" },
  { value: "07.17.01", text: "07.17.01 - Escoramento, contenção de encostas e serviços congêneres" },
  { value: "07.18.01", text: "07.18.01 - Limpeza e dragagem de rios, portos, canais, baías, lagos, lagoas, represas, açudes e congêneres" },
  { value: "07.19.01", text: "07.19.01 - Acompanhamento e fiscalização da execução de obras de engenharia, arquitetura e urbanismo" },
  { value: "07.20.01", text: "07.20.01 - Aerofotogrametria (inclusive interpretação), cartografia, mapeamento e congêneres" },
  { value: "07.20.02", text: "07.20.02 - Levantamentos batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres" },
  { value: "07.20.03", text: "07.20.03 - Levantamentos topográficos e congêneres" },
  { value: "07.21.01", text: "07.21.01 - Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais" },
  { value: "07.22.01", text: "07.22.01 - Nucleação e bombardeamento de nuvens e congêneres" },
  { value: "08.01.01", text: "08.01.01 - Ensino regular pré-escolar, fundamental e médio" },
  { value: "08.01.02", text: "08.01.02 - Ensino regular superior" },
  { value: "08.02.01", text: "08.02.01 - Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza" },
  { value: "09.01.01", text: "09.01.01 - Hospedagem em hotéis, hotelaria marítima e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)" },
  { value: "09.01.02", text: "09.01.02 - Hospedagem em pensões, albergues, pousadas, hospedarias, ocupação por temporada com fornecimento de serviços e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)" },
  { value: "09.01.03", text: "09.01.03 - Hospedagem em motéis e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)" },
  { value: "09.01.04", text: "09.01.04 - Hospedagem em apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)" },
  { value: "09.02.01", text: "09.02.01 - Agenciamento e intermediação de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres" },
  { value: "09.02.02", text: "09.02.02 - Organização, promoção e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres" },
  { value: "09.03.01", text: "09.03.01 - Guias de turismo" },
  { value: "10.01.01", text: "10.01.01 - Agenciamento, corretagem ou intermediação de câmbio" },
  { value: "10.01.02", text: "10.01.02 - Agenciamento, corretagem ou intermediação de seguros" },
  { value: "10.01.03", text: "10.01.03 - Agenciamento, corretagem ou intermediação de cartões de crédito" },
  { value: "10.01.04", text: "10.01.04 - Agenciamento, corretagem ou intermediação de planos de saúde" },
  { value: "10.01.05", text: "10.01.05 - Agenciamento, corretagem ou intermediação de planos de previdência privada" },
  { value: "10.02.01", text: "10.02.01 - Agenciamento, corretagem ou intermediação de títulos em geral e valores mobiliários" },
  { value: "10.02.02", text: "10.02.02 - Agenciamento, corretagem ou intermediação de contratos quaisquer" },
  { value: "10.03.01", text: "10.03.01 - Agenciamento, corretagem ou intermediação de direitos de propriedade industrial, artística ou literária" },
  { value: "10.04.01", text: "10.04.01 - Agenciamento, corretagem ou intermediação de contratos de arrendamento mercantil (leasing)" },
  { value: "10.04.02", text: "10.04.02 - Agenciamento, corretagem ou intermediação de contratos de franquia (franchising)" },
  { value: "10.04.03", text: "10.04.03 - Agenciamento, corretagem ou intermediação de faturização (factoring)" },
  { value: "10.05.01", text: "10.05.01 - Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, por quaisquer meios" },
  { value: "10.05.02", text: "10.05.02 - Agenciamento, corretagem ou intermediação de bens móveis ou imóveis realizados no âmbito de Bolsas de Mercadorias e Futuros, por quaisquer meios" },
  { value: "10.06.01", text: "10.06.01 - Agenciamento marítimo" },
  { value: "10.07.01", text: "10.07.01 - Agenciamento de notícias" },
  { value: "10.08.01", text: "10.08.01 - Agenciamento de publicidade e propaganda, inclusive o agenciamento de veiculação por quaisquer meios" },
  { value: "10.09.01", text: "10.09.01 - Representação de qualquer natureza, inclusive comercial" },
  { value: "10.10.01", text: "10.10.01 - Distribuição de bens de terceiros" },
  { value: "11.01.01", text: "11.01.01 - Guarda e estacionamento de veículos terrestres automotores" },
  { value: "11.01.02", text: "11.01.02 - Guarda e estacionamento de aeronaves e de embarcações" },
  { value: "11.02.01", text: "11.02.01 - Vigilância, segurança ou monitoramento de bens, pessoas e semoventes" },
  { value: "11.03.01", text: "11.03.01 - Escolta, inclusive de veículos e cargas" },
  { value: "11.04.01", text: "11.04.01 - Armazenamento, depósito, guarda de bens de qualquer espécie" },
  { value: "11.04.02", text: "11.04.02 - Carga, descarga, arrumação de bens de qualquer espécie" },
  { value: "12.01.01", text: "12.01.01 - Espetáculos teatrais" },
  { value: "12.02.01", text: "12.02.01 - Exibições cinematográficas" },
  { value: "12.03.01", text: "12.03.01 - Espetáculos circenses" },
  { value: "12.04.01", text: "12.04.01 - Programas de auditório" },
  { value: "12.05.01", text: "12.05.01 - Parques de diversões, centros de lazer e congêneres" },
  { value: "12.06.01", text: "12.06.01 - Boates, taxi-dancing e congêneres" },
  { value: "12.07.01", text: "12.07.01 - Shows, ballet, danças, desfiles, bailes, óperas, concertos, recitais, festivais e congêneres" },
  { value: "12.08.01", text: "12.08.01 - Feiras, exposições, congressos e congêneres" },
  { value: "12.09.01", text: "12.09.01 - Bilhares" },
  { value: "12.09.02", text: "12.09.02 - Boliches" },
  { value: "12.09.03", text: "12.09.03 - Diversões eletrônicas ou não" },
  { value: "12.10.01", text: "12.10.01 - Corridas e competições de animais" },
  { value: "12.11.01", text: "12.11.01 - Competições esportivas ou de destreza física ou intelectual, com ou sem a participação do espectador" },
  { value: "12.12.01", text: "12.12.01 - Execução de música" },
  { value: "12.13.01", text: "12.13.01 - Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres." },
  { value: "12.14.01", text: "12.14.01 - Fornecimento de música para ambientes fechados ou não, mediante transmissão por qualquer processo" },
  { value: "12.15.01", text: "12.15.01 - Desfiles de blocos carnavalescos ou folclóricos, trios elétricos e congêneres" },
  { value: "12.16.01", text: "12.16.01 - Exibição de filmes, entrevistas, musicais, espetáculos, shows, concertos, desfiles, óperas, competições esportivas, de destreza intelectual ou congêneres" },
  { value: "12.17.01", text: "12.17.01 - Recreação e animação, inclusive em festas e eventos de qualquer natureza." },
  { value: "13.02.01", text: "13.02.01 - Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres" },
  { value: "13.03.01", text: "13.03.01 - Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres" },
  { value: "13.04.01", text: "13.04.01 - Reprografia, microfilmagem e digitalização" },
  { value: "13.05.01", text: "13.05.01 - Composição gráfica, inclusive confecção de impressos gráficos, fotocomposição, clicheria, zincografia, litografia e fotolitografia, exceto se destinados a posterior operação de comercialização ou industrialização, ainda que incorporados, de qualquer forma, a outra mercadoria que deva ser objeto de posterior circulação, tais como bulas, rótulos, etiquetas, caixas, cartuchos, embalagens e manuais técnicos e de instrução, quando ficarão sujeitos ao ICMS" },
  { value: "14.01.01", text: "14.01.01 - Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)" },
  { value: "14.02.01", text: "14.02.01 - Assistência técnica" },
  { value: "14.03.01", text: "14.03.01 - Recondicionamento de motores (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)" },
  { value: "14.04.01", text: "14.04.01 - Recauchutagem ou regeneração de pneus" },
  { value: "14.05.01", text: "14.05.01 - Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, plastificação, costura, acabamento, polimento e congêneres de objetos quaisquer" },
  { value: "14.06.01", text: "14.06.01 - Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido" },
  { value: "14.07.01", text: "14.07.01 - Colocação de molduras e congêneres" },
  { value: "14.08.01", text: "14.08.01 - Encadernação, gravação e douração de livros, revistas e congêneres" },
  { value: "14.09.01", text: "14.09.01 - Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento" },
  { value: "14.10.01", text: "14.10.01 - Tinturaria e lavanderia" },
  { value: "14.11.01", text: "14.11.01 - Tapeçaria e reforma de estofamentos em geral" },
  { value: "14.12.01", text: "14.12.01 - Funilaria e lanternagem" },
  { value: "14.13.01", text: "14.13.01 - Carpintaria" },
  { value: "14.13.02", text: "14.13.02 - Serralheria" },
  { value: "14.14.01", text: "14.14.01 - Guincho intramunicipal" },
  { value: "14.14.02", text: "14.14.02 - Guindaste e içamento" },
  { value: "15.01.01", text: "15.01.01 - Administração de fundos quaisquer e congêneres" },
  { value: "15.01.02", text: "15.01.02 - Administração de consórcio e congêneres" },
  { value: "15.01.03", text: "15.01.03 - Administração de cartão de crédito ou débito e congêneres" },
  { value: "15.01.04", text: "15.01.04 - Administração de carteira de clientes e congêneres" },
  { value: "15.01.05", text: "15.01.05 - Administração de cheques pré-datados e congêneres" },
  { value: "15.02.01", text: "15.02.01 - Abertura de conta-corrente no País, bem como a manutenção da referida conta ativa e inativa." },
  { value: "15.02.02", text: "15.02.02 - Abertura de conta-corrente no exterior, bem como a manutenção da referida conta ativa e inativa." },
  { value: "15.02.03", text: "15.02.03 - Abertura de conta de investimentos e aplicação no País, bem como a manutenção da referida conta ativa e inativa." },
  { value: "15.02.04", text: "15.02.04 - Abertura de conta de investimentos e aplicação no exterior, bem como a manutenção da referida conta ativa e inativa." },
  { value: "15.02.05", text: "15.02.05 - Abertura de caderneta de poupança no País, bem como a manutenção da referida conta ativa e inativa." },
  { value: "15.02.06", text: "15.02.06 - Abertura de caderneta de poupança no exterior, bem como a manutenção da referida conta ativa e inativa." },
  { value: "15.02.07", text: "15.02.07 - Abertura de contas em geral no País, não abrangida em outro subitem, bem como a manutenção das referidas contas ativas e inativas." },
  { value: "15.02.08", text: "15.02.08 - Abertura de contas em geral no exterior, não abrangida em outro subitem, bem como a manutenção das referidas contas ativas e inativas." },
  { value: "15.03.01", text: "15.03.01 - Locação de cofres particulares." },
  { value: "15.03.02", text: "15.03.02 - Manutenção de cofres particulares." },
  { value: "15.03.03", text: "15.03.03 - Locação de terminais eletrônicos." },
  { value: "15.03.04", text: "15.03.04 - Manutenção de terminais eletrônicos." },
  { value: "15.03.05", text: "15.03.05 - Locação de terminais de atendimento." },
  { value: "15.03.06", text: "15.03.06 - Manutenção de terminais de atendimento." },
  { value: "15.03.07", text: "15.03.07 - Locação de bens e equipamentos em geral." },
  { value: "15.03.08", text: "15.03.08 - Manutenção de bens e equipamentos em geral." },
  { value: "15.04.01", text: "15.04.01 - Fornecimento ou emissão de atestados em geral, inclusive atestado de idoneidade, atestado de capacidade financeira e congêneres." },
  { value: "15.05.01", text: "15.05.01 - Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres." },
  { value: "15.05.02", text: "15.05.02 - Inclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF." },
  { value: "15.05.03", text: "15.05.03 - Exclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF." },
  { value: "15.05.04", text: "15.05.04 - Inclusão em quaisquer outros bancos cadastrais." },
  { value: "15.05.05", text: "15.05.05 - Exclusão em quaisquer outros bancos cadastrais." },
  { value: "15.06.01", text: "15.06.01 - Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral" },
  { value: "15.06.02", text: "15.06.02 - Abono de firmas." },
  { value: "15.06.03", text: "15.06.03 - Coleta e entrega de documentos, bens e valores." },
  { value: "15.06.04", text: "15.06.04 - Comunicação com outra agência ou com a administração central." },
  { value: "15.06.05", text: "15.06.05 - Licenciamento eletrônico de veículos." },
  { value: "15.06.06", text: "15.06.06 - Transferência de veículos." },
  { value: "15.06.07", text: "15.06.07 - Agenciamento fiduciário ou depositário." },
  { value: "15.06.08", text: "15.06.08 - Devolução de bens em custódia." },
  { value: "15.07.01", text: "15.07.01 - Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex." },
  { value: "15.07.02", text: "15.07.02 - Acesso a terminais de atendimento, inclusive vinte e quatro horas." },
  { value: "15.07.03", text: "15.07.03 - Acesso a outro banco e à rede compartilhada." },
  { value: "15.07.04", text: "15.07.04 - Fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo." },
  { value: "15.08.01", text: "15.08.01 - Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito." },
  { value: "15.08.02", text: "15.08.02 - Estudo, análise e avaliação de operações de crédito." },
  { value: "15.08.03", text: "15.08.03 - Emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres." },
  { value: "15.08.04", text: "15.08.04 - Serviços relativos à abertura de crédito, para quaisquer fins." },
  { value: "15.09.01", text: "15.09.01 - Arrendamento mercantil (leasing) de quaisquer bens, inclusive cessão de direitos e obrigações, substituição de garantia, alteração, cancelamento e registro de contrato, e demais serviços relacionados ao arrendamento mercantil (leasing)" },
  { value: "15.10.01", text: "15.10.01 - Serviços relacionados a cobranças em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento" },
  { value: "15.10.02", text: "15.10.02 - Serviços relacionados a recebimentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento" },
  { value: "15.10.03", text: "15.10.03 - Serviços relacionados a pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento" },
  { value: "15.10.04", text: "15.10.04 - Serviços relacionados a fornecimento de posição de cobrança, recebimento ou pagamento." },
  { value: "15.10.05", text: "15.10.05 - Serviços relacionados a emissão de carnês, fichas de compensação, impressos e documentos em geral." },
  { value: "15.11.01", text: "15.11.01 - Devolução de títulos, protesto de títulos, sustação de protesto, manutenção de títulos, reapresentação de títulos, e demais serviços a eles relacionados." },
  { value: "15.12.01", text: "15.12.01 - Custódia em geral, inclusive de títulos e valores mobiliários." },
  { value: "15.13.01", text: "15.13.01 - Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio." },
  { value: "15.13.02", text: "15.13.02 - Serviços relacionados a emissão de registro de exportação ou de crédito." },
  { value: "15.13.03", text: "15.13.03 - Serviços relacionados a cobrança ou depósito no exterior." },
  { value: "15.13.04", text: "15.13.04 - Serviços relacionados a emissão, fornecimento e cancelamento de cheques de viagem." },
  { value: "15.13.05", text: "15.13.05 - Serviços relacionados a fornecimento, transferência, cancelamento e demais serviços relativos a carta de crédito de importação, exportação e garantias recebidas." },
  { value: "15.13.06", text: "15.13.06 - Serviços relacionados a envio e recebimento de mensagens em geral relacionadas a operações de câmbio." },
  { value: "15.14.01", text: "15.14.01 - Fornecimento, emissão, reemissão de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres." },
  { value: "15.14.02", text: "15.14.02 - Renovação de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres." },
  { value: "15.14.03", text: "15.14.03 - Manutenção de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres." },
  { value: "15.15.01", text: "15.15.01 - Compensação de cheques e títulos quaisquer." },
  { value: "15.15.02", text: "15.15.02 - Serviços relacionados a depósito, inclusive depósito identificado, a saque de contas quaisquer, por qualquer meio ou processo, inclusive em terminais eletrônicos e de atendimento" },
  { value: "15.16.01", text: "15.16.01 - Emissão, reemissão, liquidação, alteração, cancelamento e baixa de ordens de pagamento, ordens de crédito e similares, por qualquer meio ou processo." },
  { value: "15.16.02", text: "15.16.02 - Serviços relacionados à transferência de valores, dados, fundos, pagamentos e similares, inclusive entre contas em geral." },
  { value: "15.17.01", text: "15.17.01 - Emissão e fornecimento de cheques quaisquer, avulso ou por talão." },
  { value: "15.17.02", text: "15.17.02 - Devolução de cheques quaisquer, avulso ou por talão." },
  { value: "15.17.03", text: "15.17.03 - Sustação, cancelamento e oposição de cheques quaisquer, avulso ou por talão." },
  { value: "15.18.01", text: "15.18.01 - Serviços relacionados a crédito imobiliário, de avaliação e vistoria de imóvel ou obra." },
  { value: "15.18.02", text: "15.18.02 - Serviços relacionados a crédito imobiliário, de análise técnica e jurídica." },
  { value: "15.18.03", text: "15.18.03 - Serviços relacionados a crédito imobiliário, de emissão, reemissão, alteração, transferência e renegociação de contrato." },
  { value: "15.18.04", text: "15.18.04 - Serviços relacionados a crédito imobiliário, de emissão e reemissão do termo de quitação." },
  { value: "15.18.05", text: "15.18.05 - Demais serviços relacionados a crédito imobiliário." },
  { value: "16.01.01", text: "16.01.01 - Serviços de transporte coletivo municipal rodoviário de passageiros." },
  { value: "16.01.02", text: "16.01.02 - Serviços de transporte coletivo municipal metroviário de passageiros." },
  { value: "16.01.03", text: "16.01.03 - Serviços de transporte coletivo municipal ferroviário de passageiros." },
  { value: "16.01.04", text: "16.01.04 - Serviços de transporte coletivo municipal aquaviário de passageiros." },
  { value: "16.02.01", text: "16.02.01 - Outros serviços de transporte de natureza municipal." },
  { value: "17.01.01", text: "17.01.01 - Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista." },
  { value: "17.01.02", text: "17.01.02 - Análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares." },
  { value: "17.02.01", text: "17.02.01 - Datilografia, digitação, estenografia e congêneres." },
  { value: "17.02.02", text: "17.02.02 - Expediente, secretaria em geral, apoio e infra-estrutura administrativa e congêneres." },
  { value: "17.02.03", text: "17.02.03 - Resposta audível e congêneres." },
  { value: "17.02.04", text: "17.02.04 - Redação, edição, revisão e congêneres." },
  { value: "17.02.05", text: "17.02.05 - Interpretação, tradução e congêneres." },
  { value: "17.03.01", text: "17.03.01 - Planejamento, coordenação, programação ou organização técnica." },
  { value: "17.03.02", text: "17.03.02 - Planejamento, coordenação, programação ou organização financeira." },
  { value: "17.03.03", text: "17.03.03 - Planejamento, coordenação, programação ou organização administrativa." },
  { value: "17.04.01", text: "17.04.01 - Recrutamento, agenciamento, seleção e colocação de mão-de-obra." },
  { value: "17.05.01", text: "17.05.01 - Fornecimento de mão-de-obra, mesmo em caráter temporário, inclusive de empregados ou trabalhadores, avulsos ou temporários, contratados pelo prestador de serviço" },
  { value: "17.06.01", text: "17.06.01 - Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários" },
  { value: "17.08.01", text: "17.08.01 - Franquia (franchising)." },
  { value: "17.09.01", text: "17.09.01 - Perícias, laudos, exames técnicos e análises técnicas." },
  { value: "17.10.01", text: "17.10.01 - Planejamento, organização e administração de feiras, exposições, e congêneres." },
  { value: "17.10.02", text: "17.10.02 - Planejamento, organização e administração de congressos e congêneres." },
  { value: "17.11.01", text: "17.11.01 - Organização de festas e recepções." },
  { value: "17.11.02", text: "17.11.02 - Bufê (exceto o fornecimento de alimentação e bebidas, que fica sujeito ao ICMS)." },
  { value: "17.12.01", text: "17.12.01 - Administração em geral, inclusive de bens e negócios de terceiros." },
  { value: "17.13.01", text: "17.13.01 - Leilão e congêneres." },
  { value: "17.14.01", text: "17.14.01 - Advocacia." },
  { value: "17.15.01", text: "17.15.01 - Arbitragem de qualquer espécie, inclusive jurídica." },
  { value: "17.16.01", text: "17.16.01 - Auditoria." },
  { value: "17.17.01", text: "17.17.01 - Análise de Organização e Métodos." },
  { value: "17.18.01", text: "17.18.01 - Atuária e cálculos técnicos de qualquer natureza." },
  { value: "17.19.01", text: "17.19.01 - Contabilidade, inclusive serviços técnicos e auxiliares." },
  { value: "17.20.01", text: "17.20.01 - Consultoria e assessoria econômica ou financeira." },
  { value: "17.21.01", text: "17.21.01 - Estatística." },
  { value: "17.22.01", text: "17.22.01 - Cobrança em geral." },
  { value: "17.23.01", text: "17.23.01 - Assessoria, análise, avaliação, atendimento, consulta, cadastro, seleção, gerenciamento de informações, administração de contas a receber ou a pagar e em geral, relacionados a operações de faturização (factoring)" },
  { value: "17.24.01", text: "17.24.01 - Apresentação de palestras, conferências, seminários e congêneres." },
  { value: "17.25.01", text: "17.25.01 - Inserção de textos, desenhos e outros materiais de propaganda e publicidade, em qualquer meio (exceto em livros, jornais, periódicos e nas modalidades de serviços de radiodifusão sonora e de sons e imagens de recepção livre e gratuita)" },
  { value: "18.01.01", text: "18.01.01 - Serviços de regulação de sinistros vinculados a contratos de seguros e congêneres." },
  { value: "18.01.02", text: "18.01.02 - Serviços de inspeção e avaliação de riscos para cobertura de contratos de seguros e congêneres." },
  { value: "18.01.03", text: "18.01.03 - Serviços de prevenção e gerência de riscos seguráveis e congêneres." },
  { value: "19.01.01", text: "19.01.01 - Serviços de distribuição e venda de bilhetes e demais produtos de loteria, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres." },
  { value: "19.01.02", text: "19.01.02 - Serviços de distribuição e venda de bingos e congêneres." },
  { value: "20.01.01", text: "20.01.01 - Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres." },
  { value: "20.02.01", text: "20.02.01 - Serviços aeroportuários, utilização de aeroporto, movimentação de passageiros, armazenagem de qualquer natureza, capatazia, movimentação de aeronaves, serviços de apoio aeroportuários, serviços acessórios, movimentação de mercadorias, logística e congêneres." },
  { value: "20.03.01", text: "20.03.01 - Serviços de terminais rodoviários, ferroviários, metroviários, movimentação de passageiros, mercadorias, inclusive suas operações, logística e congêneres" },
  { value: "21.01.01", text: "21.01.01 - Serviços de registros públicos, cartorários e notariais." },
  { value: "22.01.01", text: "22.01.01 - Serviços de exploração de rodovia mediante cobrança de preço ou pedágio dos usuários, envolvendo execução de serviços de conservação, manutenção, melhoramentos para adequação de capacidade e segurança de trânsito, operação, monitoração, assistência aos usuários e outros serviços definidos em contratos, atos de concessão ou de permissão ou em normas oficiais." },
  { value: "23.01.01", text: "23.01.01 - Serviços de programação e comunicação visual e congêneres." },
  { value: "23.01.02", text: "23.01.02 - Serviços de desenho industrial e congêneres." },
  { value: "24.01.01", text: "24.01.01 - Serviços de chaveiros, confecção de carimbos e congêneres." },
  { value: "24.01.02", text: "24.01.02 - Serviços de placas, sinalização visual, banners, adesivos e congêneres." },
  { value: "25.01.01", text: "25.01.01 - Funerais, inclusive fornecimento de caixão, urna ou esquifes ;aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros adornos; embalsamento, embelezamento, conservação ou restauração de cadáveres." },
  { value: "25.02.01", text: "25.02.01 - Translado intramunicipal de corpos e partes de corpos cadavéricos." },
  { value: "25.02.02", text: "25.02.02 - Cremação de corpos e partes de corpos cadavéricos." },
  { value: "25.03.01", text: "25.03.01 - Planos ou convênio funerários." },
  { value: "25.04.01", text: "25.04.01 - Manutenção e conservação de jazigos e cemitérios." },
  { value: "25.05.01", text: "25.05.01 - Cessão de uso de espaços em cemitérios para sepultamento." },
  { value: "26.01.01", text: "26.01.01 - Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas." },
  { value: "26.01.02", text: "26.01.02 - Serviços de courrier e congêneres." },
  { value: "27.01.01", text: "27.01.01 - Serviços de assistência social." },
  { value: "28.01.01", text: "28.01.01 - Serviços de avaliação de bens e serviços de qualquer natureza." },
  { value: "29.01.01", text: "29.01.01 - Serviços de biblioteconomia." },
  { value: "30.01.01", text: "30.01.01 - Serviços de biologia e biotecnologia." },
  { value: "30.01.02", text: "30.01.02 - Serviços de química." },
  { value: "31.01.01", text: "31.01.01 - Serviços técnicos em edificações e congêneres." },
  { value: "31.01.02", text: "31.01.02 - Serviços técnicos em eletrônica, eletrotécnica e congêneres." },
  { value: "31.01.03", text: "31.01.03 - Serviços técnicos em mecânica e congêneres." },
  { value: "31.01.04", text: "31.01.04 - Serviços técnicos em telecomunicações e congêneres." },
  { value: "32.01.01", text: "32.01.01 - Serviços de desenhos técnicos." },
  { value: "33.01.01", text: "33.01.01 - Serviços de desembaraço aduaneiro, comissários, despachantes e congêneres." },
  { value: "34.01.01", text: "34.01.01 - Serviços de investigações particulares, detetives e congêneres." },
  { value: "35.01.01", text: "35.01.01 - Serviços de reportagem e jornalismo." },
  { value: "35.01.02", text: "35.01.02 - Serviços de assessoria de imprensa." },
  { value: "35.01.03", text: "35.01.03 - Serviços de relações públicas." },
  { value: "36.01.01", text: "36.01.01 - Serviços de meteorologia." },
  { value: "37.01.01", text: "37.01.01 - Serviços de artistas, atletas, modelos e manequins." },
  { value: "38.01.01", text: "38.01.01 - Serviços de museologia." },
  { value: "39.01.01", text: "39.01.01 - Serviços de ourivesaria e lapidação (quando o material for fornecido pelo tomador do serviço)." },
  { value: "40.01.01", text: "40.01.01 - Obras de arte sob encomenda." },
  { value: "99.01.01", text: "99.01.01 - Serviços sem a incidência de ISSQN e ICMS" }
];
const codesNbs = [
  {
    "value": "101011100",
    "text": "101011100 - Serviços de construção de edificações residenciais de um e dois pavimentos"
  },
  {
    "value": "101011200",
    "text": "101011200 - Serviços de construção de edificações residenciais com mais de dois pavimentos"
  },
  {
    "value": "101012100",
    "text": "101012100 - Serviços de construção de edificações industriais"
  },
  {
    "value": "101012200",
    "text": "101012200 - Serviços de construção de edificações comerciais"
  },
  {
    "value": "101012900",
    "text": "101012900 - Serviços de construção de edificações não residenciais não classificados em subposições anteriores"
  },
  {
    "value": "101013000",
    "text": "101013000 - Serviços de construção de edificações de uso misto (residencial e não residencial)"
  },
  {
    "value": "101021100",
    "text": "101021100 - Serviços de construção de autoestradas (exceto autoestradas elevadas), ruas e estradas"
  },
  {
    "value": "101021200",
    "text": "101021200 - Serviços de construção de ferrovias"
  },
  {
    "value": "101021300",
    "text": "101021300 - Serviços de construção de pistas de pouso e decolagem em aeroportos e de infraestrutura aeroportuária"
  },
  {
    "value": "101022000",
    "text": "101022000 - Serviços de construção de pontes, autoestradas elevadas e túneis"
  },
  {
    "value": "101023100",
    "text": "101023100 - Serviços de construção de infraestrutura de proteção e acesso aquaviário"
  },
  {
    "value": "101023200",
    "text": "101023200 - Serviços de construção de infraestrutura de acostagem aquaviária"
  },
  {
    "value": "101023300",
    "text": "101023300 - Serviços de construção de infraestrutura terrestre e de obras de engenharia afins nos portos"
  },
  {
    "value": "101023400",
    "text": "101023400 - Serviços de construção de barragens"
  },
  {
    "value": "101023510",
    "text": "101023510 - Serviços de construção de adutoras em conduto livre"
  },
  {
    "value": "101023520",
    "text": "101023520 - Serviços de construção de sistemas de irrigação"
  },
  {
    "value": "101023530",
    "text": "101023530 - Serviços de construção relacionada ao controle dos cursos de água, inclusive canalização"
  },
  {
    "value": "101024110",
    "text": "101024110 - Serviços de construção de dutos de longo curso para o transporte de petróleo, seus derivados, e gás"
  },
  {
    "value": "101024120",
    "text": "101024120 - Serviços de construção de dutos de longo curso para o transporte e escoamento de águas"
  },
  {
    "value": "101024190",
    "text": "101024190 - Serviços de construção de dutos de longo curso não classificados em subposições anteriores"
  },
  {
    "value": "101024210",
    "text": "101024210 - Serviços de construção de linhas de comunicação de longo curso"
  },
  {
    "value": "101024220",
    "text": "101024220 - Serviços de construção de linhas de transmissão de alta tensão"
  },
  {
    "value": "101025100",
    "text": "101025100 - Serviços de construção de dutos locais"
  },
  {
    "value": "101025210",
    "text": "101025210 - Serviços de construção de linhas locais de comunicação"
  },
  {
    "value": "101025220",
    "text": "101025220 - Serviços de construção de linhas locais de transmissão de baixa e média tensão"
  },
  {
    "value": "101025310",
    "text": "101025310 - Serviços de construção de sistemas de esgotos"
  },
  {
    "value": "101025320",
    "text": "101025320 - Serviços de construção de sistemas de estações para elevação, tratamento e purificação de água"
  },
  {
    "value": "101026100",
    "text": "101026100 - Serviços de construção de usinas de geração de energia"
  },
  {
    "value": "101026900",
    "text": "101026900 - Serviços de construção de instalações industriais não classificados em subposições anteriores"
  },
  {
    "value": "101027000",
    "text": "101027000 - Serviços de construção de minas e suas unidades industriais"
  },
  {
    "value": "101028000",
    "text": "101028000 - Serviços de construção de instalações para recreação e atividades desportivas ao ar livre"
  },
  {
    "value": "101029000",
    "text": "101029000 - Serviços de construção de obras de engenharia civil não classificados em subposições anteriores"
  },
  {
    "value": "101031000",
    "text": "101031000 - Serviços de demolição"
  },
  {
    "value": "101032000",
    "text": "101032000 - Serviços de preparação de terrenos e de canteiros de obras"
  },
  {
    "value": "101033000",
    "text": "101033000 - Serviços de escavação e remoção de terra"
  },
  {
    "value": "101034100",
    "text": "101034100 - Serviços de perfuração de poços de água"
  },
  {
    "value": "101034200",
    "text": "101034200 - Serviços de instalação de sistemas sépticos"
  },
  {
    "value": "101040000",
    "text": "101040000 - Serviços de montagem e de edificação de construções pré-fabricadas"
  },
  {
    "value": "101051100",
    "text": "101051100 - Serviços de estaqueamento"
  },
  {
    "value": "101051200",
    "text": "101051200 - Serviços de fundação"
  },
  {
    "value": "101052100",
    "text": "101052100 - Serviços de construção de estruturas de edificações"
  },
  {
    "value": "101052200",
    "text": "101052200 - Serviços de construção de estruturas de telhados e coberturas"
  },
  {
    "value": "101053000",
    "text": "101053000 - Serviços de construção de telhados e coberturas e serviços de impermeabilização"
  },
  {
    "value": "101054000",
    "text": "101054000 - Serviços de concretagem"
  },
  {
    "value": "101055000",
    "text": "101055000 - Serviços de montagem de estruturas de aço"
  },
  {
    "value": "101056000",
    "text": "101056000 - Serviços de alvenaria"
  },
  {
    "value": "101057000",
    "text": "101057000 - Serviços de andaimes"
  },
  {
    "value": "101059000",
    "text": "101059000 - Serviços especializados de construção não classificados em subposições anteriores"
  },
  {
    "value": "101061100",
    "text": "101061100 - Serviços de instalação de fiação elétrica e componentes"
  },
  {
    "value": "101061200",
    "text": "101061200 - Serviços de instalação de alarmes contra incêndio"
  },
  {
    "value": "101061300",
    "text": "101061300 - Serviços de instalação de sistemas de alarmes antifurto"
  },
  {
    "value": "101061400",
    "text": "101061400 - Serviços de instalação de antenas residenciais"
  },
  {
    "value": "101061900",
    "text": "101061900 - Serviços de instalação elétrica não classificados em subposições anteriores"
  },
  {
    "value": "101062100",
    "text": "101062100 - Serviços de instalação de tubulação para fornecimento de água"
  },
  {
    "value": "101062200",
    "text": "101062200 - Serviços de instalação de tubulação para escoamento de água"
  },
  {
    "value": "101063100",
    "text": "101063100 - Serviços de instalação de equipamentos de aquecimento"
  },
  {
    "value": "101063200",
    "text": "101063200 - Serviços de instalação de equipamentos de ventilação e de ar condicionado"
  },
  {
    "value": "101064000",
    "text": "101064000 - Serviços de instalação de gás"
  },
  {
    "value": "101065000",
    "text": "101065000 - Serviços de instalação de isolamentos"
  },
  {
    "value": "101066000",
    "text": "101066000 - Serviços de instalação de elevadores, esteiras e escadas rolantes"
  },
  {
    "value": "101069000",
    "text": "101069000 - Serviços de instalação não classificados em subposições anteriores"
  },
  {
    "value": "101071000",
    "text": "101071000 - Serviços de vidraçaria"
  },
  {
    "value": "101072000",
    "text": "101072000 - Serviços de gesso e de estuque"
  },
  {
    "value": "101073000",
    "text": "101073000 - Serviços de pintura"
  },
  {
    "value": "101074000",
    "text": "101074000 - Serviços de revestimento de pisos e de paredes"
  },
  {
    "value": "101075000",
    "text": "101075000 - Serviços de carpintaria e de serralharia"
  },
  {
    "value": "101076000",
    "text": "101076000 - Serviços de instalação de cercas e grades"
  },
  {
    "value": "101079000",
    "text": "101079000 - Serviços de acabamento não classificados em subposições anteriores"
  },
  {
    "value": "102010000",
    "text": "102010000 - Serviços de intermediação na distribuição de mercadorias"
  },
  {
    "value": "102020000",
    "text": "102020000 - Comércio atacadista"
  },
  {
    "value": "102030000",
    "text": "102030000 - Comércio varejista"
  },
  {
    "value": "102040000",
    "text": "102040000 - Serviços de despacho aduaneiro"
  },
  {
    "value": "102050000",
    "text": "102050000 - Serviços de intermediação na comercialização de energia elétrica"
  },
  {
    "value": "103011000",
    "text": "103011000 - Fornecimento de refeições acompanhado de serviços de restaurante"
  },
  {
    "value": "103012100",
    "text": "103012100 - Fornecimento de refeições pelo sistema de autosserviço (self-service)"
  },
  {
    "value": "103012200",
    "text": "103012200 - Fornecimento de comidas rápidas (fast-food)"
  },
  {
    "value": "103012900",
    "text": "103012900 - Fornecimento de refeições com serviços limitados de restaurante não classificado em subposições anteriores"
  },
  {
    "value": "103013100",
    "text": "103013100 - Fornecimento de alimentação para eventos"
  },
  {
    "value": "103013200",
    "text": "103013200 - Fornecimento de alimentação para operadores de transportes (comissaria ou catering)"
  },
  {
    "value": "103013900",
    "text": "103013900 - Fornecimento de alimentação, incluindo refeições, sob contrato, não classificados em subposições anteriores"
  },
  {
    "value": "103019000",
    "text": "103019000 - Fornecimento de alimentação não classificado em subposições anteriores"
  },
  {
    "value": "103020000",
    "text": "103020000 - Fornecimento de bebidas em bares, cervejarias e outros"
  },
  {
    "value": "103031100",
    "text": "103031100 - Serviços de hospedagem em quartos ou unidades de hospedagem para visitantes, com serviços diários de faxina"
  },
  {
    "value": "103031200",
    "text": "103031200 - Serviços de hospedagem em quartos ou unidades de hospedagem para visitantes, sem serviços diários de faxina"
  },
  {
    "value": "103031300",
    "text": "103031300 - Serviços de hospedagem em quartos ou unidades de hospedagem para visitantes, em propriedades partilhadas"
  },
  {
    "value": "103031400",
    "text": "103031400 - Serviços de hospedagem para visitantes, em quartos de múltipla ocupação"
  },
  {
    "value": "103032000",
    "text": "103032000 - Serviços de acampamentos turísticos (camping)"
  },
  {
    "value": "103039000",
    "text": "103039000 - Serviços de hospedagem para visitantes não classificados em subposições anteriores"
  },
  {
    "value": "103041000",
    "text": "103041000 - Serviços de hospedagem em quartos ou unidades de hospedagem para estudantes em residências estudantis"
  },
  {
    "value": "103042000",
    "text": "103042000 - Serviços de hospedagem em quartos ou unidades de hospedagem para trabalhadores em hotéis ou campos"
  },
  {
    "value": "103049000",
    "text": "103049000 - Serviços de hospedagem, exceto para visitantes, não classificados em subposições anteriores"
  },
  {
    "value": "104011111",
    "text": "104011111 - Serviços de transporte rodoviário local prestados exclusivamente por meio de ônibus"
  },
  {
    "value": "104011119",
    "text": "104011119 - Serviços de transporte rodoviário local regular de passageiros, exceto em áreas metropolitanas, não classificados em subitens anteriores"
  },
  {
    "value": "104011120",
    "text": "104011120 - Serviços de transporte rodoviário local regular de passageiros, em áreas metropolitanas"
  },
  {
    "value": "104011210",
    "text": "104011210 - Serviços de transporte escolar"
  },
  {
    "value": "104011220",
    "text": "104011220 - Serviços de transporte para aeroportos (shuttle)"
  },
  {
    "value": "104011290",
    "text": "104011290 - Serviços especiais de transporte rodoviário local regular de passageiros não classificados em itens anteriores"
  },
  {
    "value": "104011300",
    "text": "104011300 - Serviços de táxi"
  },
  {
    "value": "104011400",
    "text": "104011400 - Serviços de carro com motorista, exceto táxi"
  },
  {
    "value": "104011510",
    "text": "104011510 - Serviços de fretamento contínuo, local"
  },
  {
    "value": "104011520",
    "text": "104011520 - Serviços de fretamento eventual ou turístico, local"
  },
  {
    "value": "104011610",
    "text": "104011610 - Serviços de transporte ferroviário local de passageiros"
  },
  {
    "value": "104011620",
    "text": "104011620 - Serviços de transporte metroviário (metrô) local de passageiros"
  },
  {
    "value": "104011690",
    "text": "104011690 - Serviços de transporte local de passageiros por veículos sobre trilhos não classificados em itens anteriores"
  },
  {
    "value": "104011710",
    "text": "104011710 - Serviços de transporte rodoviário para passeios turísticos (sightseeing)"
  },
  {
    "value": "104011720",
    "text": "104011720  - Serviços de transporte ferroviário para passeios turísticos (sightseeing)"
  },
  {
    "value": "104011790",
    "text": "104011790  - Serviços de transporte terrestre para passeios turísticos (sightseeing), não classificados em itens anteriores"
  },
  {
    "value": "104011900",
    "text": "104011900 - Serviços de transporte terrestre local de passageiros, não classificados em subposições anteriores"
  },
  {
    "value": "104012110",
    "text": "104012110 - Serviços de transporte aquaviário local de passageiros, por navegação interior, em embarcações para travessia"
  },
  {
    "value": "104012120",
    "text": "104012120 - Serviços de transporte aquaviário local de passageiros, por navegação interior, em embarcações para cruzeiros"
  },
  {
    "value": "104012190",
    "text": "104012190 - Serviços de transporte aquaviário local de passageiros, por navegação interior, não classificados em itens anteriores"
  },
  {
    "value": "104012200",
    "text": "104012200 - Serviços de transporte aquaviário local de passageiros por fretamento"
  },
  {
    "value": "104012300",
    "text": "104012300  - Serviços de transporte aquaviário para passeios turísticos (sightseeing)"
  },
  {
    "value": "104012900",
    "text": "104012900  - Serviços de transporte aquaviário local de passageiros, não classificados em subposições anteriores"
  },
  {
    "value": "104013000",
    "text": "104013000 - Serviços de transporte integrado local de passageiros"
  },
  {
    "value": "104014100",
    "text": "104014100 - Serviços de táxi aéreo local"
  },
  {
    "value": "104014200",
    "text": "104014200 - Serviços de transporte aéreo local de passageiros por fretamento"
  },
  {
    "value": "104014300",
    "text": "104014300  - Serviços de transporte aéreo para passeios turísticos (sightseeing)"
  },
  {
    "value": "104014900",
    "text": "104014900 - Serviços de transporte aéreo local de passageiros, não classificados em subposições anteriores"
  },
  {
    "value": "104019000",
    "text": "104019000 - Serviços de transporte local de passageiros, não classificados em subposições anteriores"
  },
  {
    "value": "104021110",
    "text": "104021110 - Serviços de transporte rodoviário nacional, exceto local, prestados exclusivamente por meio de ônibus"
  },
  {
    "value": "104021190",
    "text": "104021190 - Serviços de transporte rodoviário nacional, exceto local, de passageiros, não classificados em subitens anteriores"
  },
  {
    "value": "104021200",
    "text": "104021200 - Serviços especiais de transporte rodoviário nacional, exceto local, regular de passageiros"
  },
  {
    "value": "104021310",
    "text": "104021310 - Serviços de fretamento contínuo, nacional, exceto local"
  },
  {
    "value": "104021320",
    "text": "104021320 - Serviços de fretamento eventual ou turístico, nacional, exceto local"
  },
  {
    "value": "104021400",
    "text": "104021400 - Serviços de transporte ferroviário nacional, exceto local, de passageiros"
  },
  {
    "value": "104021900",
    "text": "104021900 - Serviços de transporte terrestre nacional, exceto local, de passageiros, não classificados em subposições anteriores"
  },
  {
    "value": "104022110",
    "text": "104022110 - Serviços de transporte aquaviário de passageiros, por navegação interior, em embarcações para travessia"
  },
  {
    "value": "104022120",
    "text": "104022120 - Serviços de transporte aquaviário de passageiros, por navegação interior, em embarcações para cruzeiros"
  },
  {
    "value": "104022190",
    "text": "104022190 - Serviços de transporte aquaviário nacional, exceto local, de passageiros, por navegação interior, não classificados em itens anteriores"
  },
  {
    "value": "104022200",
    "text": "104022200 - Serviços de transporte aquaviário nacional costeiro de passageiros"
  },
  {
    "value": "104022300",
    "text": "104022300 - Serviços de transporte aquaviário nacional, exceto local, de passageiros, por fretamento"
  },
  {
    "value": "104023100",
    "text": "104023100 - Serviços de transporte aéreo nacional, exceto local, regular de passageiros"
  },
  {
    "value": "104023200",
    "text": "104023200 - Serviços de táxi aéreo nacional, exceto local"
  },
  {
    "value": "104023300",
    "text": "104023300 - Serviços de transporte aéreo nacional, exceto local, de passageiros, por fretamento"
  },
  {
    "value": "104023900",
    "text": "104023900 - Serviços de transporte aéreo nacional, exceto local, de passageiros, não classificados em subposições anteriores"
  },
  {
    "value": "104029000",
    "text": "104029000 - Serviços de transporte nacional, exceto local, de passageiros, não classificados em subposições anteriores"
  },
  {
    "value": "104031110",
    "text": "104031110 - Serviços de transporte de passageiros prestados exclusivamente por meio de ônibus"
  },
  {
    "value": "104031190",
    "text": "104031190 - Serviços de transporte rodoviário internacional de passageiros não classificados em itens anteriores"
  },
  {
    "value": "104031200",
    "text": "104031200 - Serviços de transporte rodoviário internacional de passageiros por fretamento"
  },
  {
    "value": "104031310",
    "text": "104031310 - Serviços de transporte internacional ferroviário de passageiros"
  },
  {
    "value": "104031390",
    "text": "104031390 - Serviços de transporte internacional de passageiros por veículos sobre trilhos não classificados em itens anteriores"
  },
  {
    "value": "104031900",
    "text": "104031900 - Serviços de transporte terrestre internacional de passageiros, não classificados em subposições anteriores"
  },
  {
    "value": "104032110",
    "text": "104032110 - Serviços de transporte aquaviário internacional de passageiros, por navegação interior, em embarcações para travessia"
  },
  {
    "value": "104032120",
    "text": "104032120 - Serviços de transporte aquaviário internacional de passageiros, por navegação interior, em embarcações para cruzeiros"
  },
  {
    "value": "104032190",
    "text": "104032190 - Serviços de transporte aquaviário internacional de passageiros, por navegação interior, não classificados em itens anteriores"
  },
  {
    "value": "104032200",
    "text": "104032200 - Serviços de transporte aquaviário internacional costeiro de passageiros"
  },
  {
    "value": "104032300",
    "text": "104032300 - Serviços de transporte aquaviário internacional transoceânico de passageiros"
  },
  {
    "value": "104032400",
    "text": "104032400 - Serviços de transporte aquaviário internacional de passageiros por fretamento"
  },
  {
    "value": "104033100",
    "text": "104033100 - Serviços de transporte aéreo internacional regular de passageiros"
  },
  {
    "value": "104033200",
    "text": "104033200 - Serviços de táxi aéreo internacional"
  },
  {
    "value": "104033300",
    "text": "104033300 - Serviços de transporte aéreo internacional de passageiros por fretamento"
  },
  {
    "value": "104033900",
    "text": "104033900 - Serviços de transporte aéreo internacional de passageiros, não classificados em subposições anteriores"
  },
  {
    "value": "104039000",
    "text": "104039000 - Serviços de transporte internacional de passageiros, não classificados em subposições anteriores"
  },
  {
    "value": "104041000",
    "text": "104041000 - Locação de veículos rodoviários de passageiros com motorista"
  },
  {
    "value": "104042000",
    "text": "104042000 - Locação de embarcações de passageiros com tripulação"
  },
  {
    "value": "104043000",
    "text": "104043000 - Locação de aeronaves de passageiros com tripulação"
  },
  {
    "value": "104050000",
    "text": "104050000 - Afretamento de embarcações de passageiros por tempo"
  },
  {
    "value": "105011110",
    "text": "105011110 - Serviços de transporte rodoviário de cargas sólidas a granel"
  },
  {
    "value": "105011120",
    "text": "105011120 - Serviços de transporte rodoviário de cargas líquidas, ou liquefeitas, a granel"
  },
  {
    "value": "105011130",
    "text": "105011130 - Serviços de transporte rodoviário de cargas gasosas a granel"
  },
  {
    "value": "105011210",
    "text": "105011210 - Serviços de transporte rodoviário de carga solta, não unitizada"
  },
  {
    "value": "105011220",
    "text": "105011220 - Serviços de transporte rodoviário de carga unitizada"
  },
  {
    "value": "105011230",
    "text": "105011230 - Serviços de transporte rodoviário de carga frigorificada ou climatizada"
  },
  {
    "value": "105011310",
    "text": "105011310 - Serviços de transporte rodoviário de cargas em contêineres frigorificados ou climatizados"
  },
  {
    "value": "105011320",
    "text": "105011320 - Serviços de transporte rodoviário de cargas em contêineres não frigorificados ou climatizados"
  },
  {
    "value": "105011410",
    "text": "105011410 - Serviços de transporte rodoviário de cargas vivas"
  },
  {
    "value": "105011420",
    "text": "105011420 - Serviços de transporte rodoviário de mudanças domésticas e de mobília e outros objetos de escritório"
  },
  {
    "value": "105011430",
    "text": "105011430 - Serviços de transporte rodoviário de cargas de grande porte"
  },
  {
    "value": "105011440",
    "text": "105011440 - Serviços de transporte rodoviário de veículos"
  },
  {
    "value": "105011451",
    "text": "105011451 - Serviços de transporte rodoviário de combustíveis, lubrificantes e GLP, inclusive apresentados em botijões metálicos"
  },
  {
    "value": "105011452",
    "text": "105011452 - Serviços de transporte rodoviário de produtos químicos perigosos, exceto lubrificantes e GLP"
  },
  {
    "value": "105011459",
    "text": "105011459 - Serviços de transporte rodoviário de produtos perigosos não classificados em subitens anteriores"
  },
  {
    "value": "105011500",
    "text": "105011500 - Serviços de transporte rodoviário de cargas postais e malotes"
  },
  {
    "value": "105011900",
    "text": "105011900 - Serviços de transporte rodoviário de cargas não classificados em subposições anteriores"
  },
  {
    "value": "105012110",
    "text": "105012110 - Serviços de transporte ferroviário de cargas sólidas a granel"
  },
  {
    "value": "105012120",
    "text": "105012120 - Serviços de transporte ferroviário de cargas líquidas, ou liquefeitas, a granel"
  },
  {
    "value": "105012130",
    "text": "105012130 - Serviços de transporte ferroviário de cargas gasosas a granel"
  },
  {
    "value": "105012210",
    "text": "105012210 - Serviços de transporte ferroviário de carga solta, não unitizada"
  },
  {
    "value": "105012220",
    "text": "105012220 - Serviços de transporte ferroviário de carga unitizada"
  },
  {
    "value": "105012230",
    "text": "105012230 - Serviços de transporte ferroviário de carga frigorificada ou climatizada"
  },
  {
    "value": "105012310",
    "text": "105012310 - Serviços de transporte ferroviário de cargas em contêineres frigorificados ou climatizados"
  },
  {
    "value": "105012320",
    "text": "105012320 - Serviços de transporte ferroviário de cargas em contêineres não frigorificados ou climatizados"
  },
  {
    "value": "105012410",
    "text": "105012410 - Serviços de transporte ferroviário de cargas vivas"
  },
  {
    "value": "105012421",
    "text": "105012421 - Serviços de transporte ferroviário de combustíveis, lubrificantes e GLP, inclusive apresentados em botijões metálicos"
  },
  {
    "value": "105012422",
    "text": "105012422 - Serviços de transporte ferroviário de produtos químicos perigosos, exceto lubrificantes e GLP"
  },
  {
    "value": "105012429",
    "text": "105012429 - Serviços de transporte ferroviário de produtos perigosos não classificados em subposições anteriores"
  },
  {
    "value": "105012500",
    "text": "105012500 - Serviços de transporte ferroviário de bens e valores"
  },
  {
    "value": "105012900",
    "text": "105012900 - Serviços de transporte ferroviário de cargas não classificados em subposições anteriores"
  },
  {
    "value": "105013100",
    "text": "105013100 - Serviços de transporte de petróleo, gás natural e combustível por meio de dutos"
  },
  {
    "value": "105013200",
    "text": "105013200 - Serviços de transporte de minérios por meio de dutos"
  },
  {
    "value": "105013900",
    "text": "105013900 - Serviços de transporte de cargas por meio de dutos não classificados em subposições anteriores"
  },
  {
    "value": "105021110",
    "text": "105021110 - Serviços de transporte aquaviário por navegação interior de cargas sólidas, a granel"
  },
  {
    "value": "105021120",
    "text": "105021120 - Serviços de transporte aquaviário por navegação interior de cargas líquidas, ou liquefeitas, a granel"
  },
  {
    "value": "105021130",
    "text": "105021130 - Serviços de transporte aquaviário por navegação interior de cargas gasosas a granel"
  },
  {
    "value": "105021210",
    "text": "105021210 - Serviços de transporte aquaviário por navegação interior de carga solta, não unitizada"
  },
  {
    "value": "105021220",
    "text": "105021220 - Serviços de transporte aquaviário por navegação interior de carga unitizada"
  },
  {
    "value": "105021230",
    "text": "105021230 - Serviços de transporte aquaviário por navegação interior de carga frigorificada ou climatizada"
  },
  {
    "value": "105021310",
    "text": "105021310 - Serviços de transporte aquaviário por navegação interior de cargas em contêineres frigorificados ou climatizados"
  },
  {
    "value": "105021320",
    "text": "105021320 - Serviços de transporte aquaviário por navegação interior de cargas em contêineres não frigorificados ou climatizados"
  },
  {
    "value": "105021410",
    "text": "105021410 - Serviços de transporte aquaviário por navegação interior de cargas vivas"
  },
  {
    "value": "105021420",
    "text": "105021420 - Serviços de transporte aquaviário por navegação interior de mudanças domésticas e de mobília e outros objetos de escritório"
  },
  {
    "value": "105021430",
    "text": "105021430 - Serviços de transporte aquaviário por navegação interior de cargas de grande porte"
  },
  {
    "value": "105021440",
    "text": "105021440 - Serviços de transporte aquaviário por navegação interior de veículos"
  },
  {
    "value": "105021451",
    "text": "105021451 - Serviços de transporte aquaviário por navegação interior de combustíveis, lubrificantes e GLP, inclusive apresentado em botijões metálicos"
  },
  {
    "value": "105021452",
    "text": "105021452 - Serviços de transporte aquaviário por navegação interior de produtos químicos perigosos, exceto lubrificantes e GLP"
  },
  {
    "value": "105021459",
    "text": "105021459 - Serviços de transporte aquaviário por navegação interior de produtos perigosos não classificados em subposições anteriores"
  },
  {
    "value": "105021490",
    "text": "105021490 - Serviços de transporte aquaviário por navegação interior de cargas especiais não classificados em subposições anteriores"
  },
  {
    "value": "105021900",
    "text": "105021900 - Serviços de transporte aquaviário por navegação interior de cargas não classificados em subposições anteriores"
  },
  {
    "value": "105022110",
    "text": "105022110 - Serviços de transporte aquaviário costeiro de cargas sólidas a granel"
  },
  {
    "value": "105022120",
    "text": "105022120 - Serviços de transporte aquaviário costeiro de cargas líquidas ou liquefeitas, a granel"
  },
  {
    "value": "105022130",
    "text": "105022130 - Serviços de transporte aquaviário costeiro de cargas gasosas a granel"
  },
  {
    "value": "105022210",
    "text": "105022210 - Serviços de transporte aquaviário costeiro de carga solta, não unitizada"
  },
  {
    "value": "105022220",
    "text": "105022220 - Serviços de transporte aquaviário costeiro de carga unitizada"
  },
  {
    "value": "105022230",
    "text": "105022230 - Serviços de transporte aquaviário costeiro de carga frigorificada ou climatizada"
  },
  {
    "value": "105022310",
    "text": "105022310 - Serviços de transporte aquaviário costeiro de cargas em contêineres frigorificados ou climatizados"
  },
  {
    "value": "105022320",
    "text": "105022320 - Serviços de transporte aquaviário costeiro de cargas em contêineres não classificados em subposições anteriores"
  },
  {
    "value": "105022410",
    "text": "105022410 - Serviços de transporte aquaviário costeiro de cargas vivas"
  },
  {
    "value": "105022420",
    "text": "105022420 - Serviços de transporte aquaviário costeiro de mudanças domésticas e de mobília e outros objetos de escritório"
  },
  {
    "value": "105022430",
    "text": "105022430 - Serviços de transporte aquaviário costeiro de cargas de grande porte"
  },
  {
    "value": "105022440",
    "text": "105022440 - Serviços de transporte aquaviário costeiro de veículos"
  },
  {
    "value": "105022451",
    "text": "105022451 - Serviços de transporte aquaviário costeiro de combustíveis, lubrificantes e GLP, inclusive apresentado em botijões metálicos"
  },
  {
    "value": "105022452",
    "text": "105022452 - Serviços de transporte aquaviário costeiro de produtos químicos perigosos, exceto lubrificantes e GLP"
  },
  {
    "value": "105022459",
    "text": "105022459 - Serviços de transporte aquaviário costeiro de produtos perigosos não classificados em subposições anteriores"
  },
  {
    "value": "105022900",
    "text": "105022900 - Serviços de transportes aquaviário costeiro de cargas não classificados em subposições anteriores"
  },
  {
    "value": "105023110",
    "text": "105023110 - Serviços de transporte aquaviário transoceânico de cargas sólidas a granel"
  },
  {
    "value": "105023120",
    "text": "105023120 - Serviços de transporte aquaviário transoceânico de cargas líquidas, ou liquefeitas, a granel"
  },
  {
    "value": "105023130",
    "text": "105023130 - Serviços de transporte aquaviário transoceânico de cargas gasosas a granel"
  },
  {
    "value": "105023210",
    "text": "105023210 - Serviços de transporte aquaviário transoceânico de carga solta, não unitizada"
  },
  {
    "value": "105023220",
    "text": "105023220 - Serviços de transporte aquaviário transoceânico de carga unitizada"
  },
  {
    "value": "105023230",
    "text": "105023230 - Serviços de transporte aquaviário transoceânico de carga frigorificada ou climatizada"
  },
  {
    "value": "105023310",
    "text": "105023310 - Serviços de transporte aquaviário transoceânico de cargas em contêineres frigorificados ou climatizados"
  },
  {
    "value": "105023320",
    "text": "105023320 - Serviços de transporte aquaviário transoceânico de cargas em contêineres não frigorificados ou climatizados"
  },
  {
    "value": "105023410",
    "text": "105023410 - Serviços de transporte aquaviário transoceânico de cargas vivas"
  },
  {
    "value": "105023420",
    "text": "105023420 - Serviços de transporte aquaviário transoceânico de mudanças domésticas e de mobília e outros objetos de escritório"
  },
  {
    "value": "105023430",
    "text": "105023430 - Serviços de transporte aquaviário transoceânico de cargas de grande porte"
  },
  {
    "value": "105023440",
    "text": "105023440 - Serviços de transporte aquaviário transoceânico de veículos"
  },
  {
    "value": "105023451",
    "text": "105023451 - Serviços de transporte aquaviário transoceânico de combustíveis, lubrificantes e GLP, inclusive apresentado em botijões metálicos"
  },
  {
    "value": "105023452",
    "text": "105023452 - Serviços de transporte aquaviário transoceânico de produtos químicos perigosos, exceto lubrificantes e GLP"
  },
  {
    "value": "105023459",
    "text": "105023459 - Serviços de transporte aquaviário transoceânico de produtos perigosos não classificados em subposições anteriores"
  },
  {
    "value": "105023900",
    "text": "105023900 - Serviços de transporte aquaviário transoceânico de cargas não classificados em subposições anteriores"
  },
  {
    "value": "105031100",
    "text": "105031100 - Serviços de transporte aéreo de cargas em contêineres frigorificados ou climatizados"
  },
  {
    "value": "105031200",
    "text": "105031200 - Serviços de transporte aéreo de cargas em contêineres não frigorificados ou climatizados"
  },
  {
    "value": "105032100",
    "text": "105032100 - Serviços de transporte aéreo de produtos perigosos"
  },
  {
    "value": "105032200",
    "text": "105032200 - Serviços de transporte aéreo de animais vivos"
  },
  {
    "value": "105032300",
    "text": "105032300 - Serviços de transporte aéreo de máquinas e veículos"
  },
  {
    "value": "105032400",
    "text": "105032400 - Serviços de transporte aéreo de perecíveis"
  },
  {
    "value": "105032500",
    "text": "105032500 - Serviços de transporte aéreo de cargas frágeis"
  },
  {
    "value": "105032600",
    "text": "105032600 - Serviços de transporte aéreo de cargas controladas"
  },
  {
    "value": "105032700",
    "text": "105032700 - Serviços de transporte aéreo de valores"
  },
  {
    "value": "105032800",
    "text": "105032800 - Serviços de transporte aéreo de cargas postais, remessas expressas e cargas congêneres"
  },
  {
    "value": "105032900",
    "text": "105032900 - Serviços de transporte aéreo de cargas especiais não classificados em subposições anteriores"
  },
  {
    "value": "105039000",
    "text": "105039000 - Serviços de transporte aéreo de cargas não classificados em subposições anteriores"
  },
  {
    "value": "105041100",
    "text": "105041100 - Serviços de transporte multimodal de cargas sólidas a granel"
  },
  {
    "value": "105041200",
    "text": "105041200 - Serviços de transporte multimodal de cargas líquidas, ou liquefeitas, a granel"
  },
  {
    "value": "105041300",
    "text": "105041300 - Serviços de transporte multimodal de cargas gasosas a granel"
  },
  {
    "value": "105042100",
    "text": "105042100 - Serviços de transporte multimodal de carga solta, não unitizada"
  },
  {
    "value": "105042200",
    "text": "105042200 - Serviços de transporte multimodal de carga unitizada"
  },
  {
    "value": "105042300",
    "text": "105042300 - Serviços de transporte multimodal de carga frigorificada ou climatizada"
  },
  {
    "value": "105043100",
    "text": "105043100 - Serviços de transporte multimodal de cargas em contêineres frigorificados ou climatizados"
  },
  {
    "value": "105043200",
    "text": "105043200 - Serviços de transporte multimodal de cargas em contêineres não frigorificados ou climatizados"
  },
  {
    "value": "105044100",
    "text": "105044100 - Serviços de transporte multimodal de cargas vivas"
  },
  {
    "value": "105044200",
    "text": "105044200 - Serviços de transporte multimodal de mudanças domésticas e de mobília e outros objetos de escritório"
  },
  {
    "value": "105044300",
    "text": "105044300 - Serviços de transporte multimodal de cargas de grande porte"
  },
  {
    "value": "105044400",
    "text": "105044400 - Serviços de transporte multimodal de veículos"
  },
  {
    "value": "105044510",
    "text": "105044510 - Serviços de transporte multimodal de combustíveis, lubrificantes e GLP, inclusive apresentado em botijões metálicos"
  },
  {
    "value": "105044520",
    "text": "105044520 - Serviços de transporte multimodal de produtos químicos perigosos, exceto lubrificantes e GLP"
  },
  {
    "value": "105044590",
    "text": "105044590 - Serviços de transporte multimodal de produtos perigosos não classificados em subposições anteriores"
  },
  {
    "value": "105044900",
    "text": "105044900 - Serviços de transporte multimodal de cargas especiais não classificados em subposições anteriores"
  },
  {
    "value": "105049000",
    "text": "105049000 - Serviços de transporte multimodal de cargas não classificados em subposições anteriores"
  },
  {
    "value": "105051000",
    "text": "105051000 - Locação de veículos rodoviários de carga com motorista"
  },
  {
    "value": "105052000",
    "text": "105052000 - Locação de embarcações de carga com tripulação"
  },
  {
    "value": "105053000",
    "text": "105053000 - Locação de aeronaves de carga com tripulação"
  },
  {
    "value": "105060000",
    "text": "105060000 - Afretamento de embarcações de carga por tempo"
  },
  {
    "value": "106011000",
    "text": "106011000  - Serviços de manuseio de contêineres"
  },
  {
    "value": "106019000",
    "text": "106019000  - Serviços de manuseio de cargas não classificados em subposições anteriores"
  },
  {
    "value": "106021000",
    "text": "106021000  - Serviços de armazenagem frigorificada"
  },
  {
    "value": "106022100",
    "text": "106022100 - Serviços de armazenagem de petróleo e seus derivados"
  },
  {
    "value": "106022200",
    "text": "106022200 - Serviços de armazenagem de combustíveis, lubrificantes e GLP, inclusive apresentado em botijões metálicos"
  },
  {
    "value": "106022300",
    "text": "106022300 - Serviços de armazenagem de produtos químicos perigosos"
  },
  {
    "value": "106022900",
    "text": "106022900 - Serviços de armazenagem de outros produtos perigosos"
  },
  {
    "value": "106023100",
    "text": "106023100 - Serviços de armazenagem de granéis sólidos"
  },
  {
    "value": "106023200",
    "text": "106023200 - Serviços de armazenagem de granéis líquidos ou liquefeitos"
  },
  {
    "value": "106023300",
    "text": "106023300 - Serviços de armazenagem de granéis gasosos"
  },
  {
    "value": "106029000",
    "text": "106029000  - Serviços de armazenagem não classificados em subposições anteriores"
  },
  {
    "value": "106030000",
    "text": "106030000  - Serviços de apoio ao transporte ferroviário"
  },
  {
    "value": "106041000",
    "text": "106041000  - Serviços de estações rodoviárias"
  },
  {
    "value": "106042100",
    "text": "106042100 - Serviços de operação de rodovias"
  },
  {
    "value": "106042200",
    "text": "106042200 - Serviços de operação de pontes e túneis"
  },
  {
    "value": "106043000",
    "text": "106043000  - Serviços de estacionamento"
  },
  {
    "value": "106044000",
    "text": "106044000  - Serviços de reboque para veículos particulares e comerciais"
  },
  {
    "value": "106049000",
    "text": "106049000  - Serviços de apoio ao transporte rodoviário não classificados em subposições anteriores"
  },
  {
    "value": "106051000",
    "text": "106051000  - Serviços de operação de portos e canais, exceto manuseio de cargas"
  },
  {
    "value": "106052000",
    "text": "106052000  - Serviços de praticagem e de atracação"
  },
  {
    "value": "106053000",
    "text": "106053000  - Serviços de salvamento de embarcações"
  },
  {
    "value": "106054000",
    "text": "106054000 - Serviços de navegação de apoio"
  },
  {
    "value": "106059000",
    "text": "106059000  - Serviços de apoio ao transporte aquaviário não classificados em subposições anteriores"
  },
  {
    "value": "106061100",
    "text": "106061100  - Serviços de operação aeroportuária, exceto manuseio de cargas"
  },
  {
    "value": "106061200",
    "text": "106061200  - Serviços de controle de tráfego aéreo"
  },
  {
    "value": "106061900",
    "text": "106061900  - Serviços de apoio ao transporte aéreo não classificados em suposições anteriores"
  },
  {
    "value": "106062000",
    "text": "106062000  - Serviços de apoio ao transporte aeroespacial"
  },
  {
    "value": "106070000",
    "text": "106070000 - Serviços de agenciamento de transporte de cargas"
  },
  {
    "value": "106081000",
    "text": "106081000  - Serviços de coleta e entrega de cargas no transporte multimodal"
  },
  {
    "value": "106082000",
    "text": "106082000  - Serviços de unitização ou desunitização de cargas no transporte multimodal"
  },
  {
    "value": "106083000",
    "text": "106083000  - Serviços de movimentação de cargas no transporte multimodal"
  },
  {
    "value": "106084000",
    "text": "106084000  - Serviços de consolidação ou desconsolidação documental de cargas no transporte multimodal"
  },
  {
    "value": "106089000",
    "text": "106089000  - Serviços de apoio ao transporte multimodal de cargas não classificados em subposições anteriores"
  },
  {
    "value": "106090000",
    "text": "106090000 - Serviços de apoio aos transportes não classificados em posições anteriores"
  },
  {
    "value": "107010000",
    "text": "107010000 - Serviços postais e de telegrama"
  },
  {
    "value": "107020000",
    "text": "107020000 - Serviços de coleta, transporte, remessa ou entrega de documentos ou encomendas, exceto remessas expressas"
  },
  {
    "value": "107030000",
    "text": "107030000 - Serviços de remessas expressas"
  },
  {
    "value": "108011000",
    "text": "108011000 - Serviços de transmissão de eletricidade"
  },
  {
    "value": "108012000",
    "text": "108012000 - Serviços de distribuição de eletricidade"
  },
  {
    "value": "108021000",
    "text": "108021000 - Serviços de distribuição de água por meio de tubulações, exceto vapor de água e água quente"
  },
  {
    "value": "108022000",
    "text": "108022000 - Serviços de distribuição de vapor de água, água quente e ar condicionado por meio de tubulações"
  },
  {
    "value": "108023000",
    "text": "108023000 - Serviços de distribuição de água, exceto por meio de tubulações"
  },
  {
    "value": "108030000",
    "text": "108030000 - Serviços de distribuição de gás canalizado"
  },
  {
    "value": "109011000",
    "text": "109011000 - Serviços de banco central"
  },
  {
    "value": "109012100",
    "text": "109012100 - Serviços de depósito para pessoas jurídicas"
  },
  {
    "value": "109012200",
    "text": "109012200 - Serviços de depósito para pessoas físicas"
  },
  {
    "value": "109012900",
    "text": "109012900 - Serviços de depósito para outros depositantes"
  },
  {
    "value": "109013100",
    "text": "109013100 - Serviços de financiamentos imobiliários residenciais"
  },
  {
    "value": "109013200",
    "text": "109013200 - Serviços de financiamentos imobiliários não residenciais"
  },
  {
    "value": "109013300",
    "text": "109013300 - Serviços de empréstimos e financiamentos pessoais"
  },
  {
    "value": "109013400",
    "text": "109013400 - Serviços de empréstimos e financiamentos comerciais"
  },
  {
    "value": "109013500",
    "text": "109013500 - Serviços de empréstimos e financiamentos industriais"
  },
  {
    "value": "109013600",
    "text": "109013600 - Serviços de empréstimos e financiamentos agropecuários"
  },
  {
    "value": "109013900",
    "text": "109013900 - Serviços de concessão de crédito não classificados em subposições anteriores"
  },
  {
    "value": "109014000",
    "text": "109014000 - Serviços de cartão de crédito"
  },
  {
    "value": "109015111",
    "text": "109015111 - Arrendamento mercantil financeiro de veículos rodoviários automotores para o transporte de passageiros"
  },
  {
    "value": "109015112",
    "text": "109015112 - Arrendamento mercantil financeiro de veículos rodoviários automotores para o transporte de mercadorias"
  },
  {
    "value": "109015113",
    "text": "109015113 - Arrendamento mercantil financeiro de veículos e equipamentos ferroviários"
  },
  {
    "value": "109015114",
    "text": "109015114 - Arrendamento mercantil financeiro de outros equipamentos de transporte terrestre, inclusive de veículos de uso misto"
  },
  {
    "value": "109015115",
    "text": "109015115 - Arrendamento mercantil financeiro de navios e outras embarcações"
  },
  {
    "value": "109015116",
    "text": "109015116 - Arrendamento mercantil financeiro de aeronaves"
  },
  {
    "value": "109015117",
    "text": "109015117 - Arrendamento mercantil financeiro de contêineres"
  },
  {
    "value": "109015121",
    "text": "109015121 - Arrendamento mercantil financeiro de máquinas e equipamentos agrícolas"
  },
  {
    "value": "109015122",
    "text": "109015122 - Arrendamento mercantil financeiro de máquinas e equipamentos de construção"
  },
  {
    "value": "109015123",
    "text": "109015123 - Arrendamento mercantil financeiro de máquinas e equipamentos para escritórios, exceto computadores"
  },
  {
    "value": "109015124",
    "text": "109015124 - Arrendamento mercantil financeiro de computadores"
  },
  {
    "value": "109015125",
    "text": "109015125 - Arrendamento mercantil financeiro de equipamentos de telecomunicação"
  },
  {
    "value": "109015129",
    "text": "109015129 - Arrendamento mercantil financeiro de outras máquinas e equipamentos não classificado em subposições anteriores"
  },
  {
    "value": "109015210",
    "text": "109015210 - Arrendamento mercantil financeiro de televisão e outros eletroeletrônicos domésticos, bem como seus acessórios"
  },
  {
    "value": "109015220",
    "text": "109015220 - Arrendamento mercantil financeiro de mídias gravadas"
  },
  {
    "value": "109015230",
    "text": "109015230 - Arrendamento mercantil financeiro de móveis e eletrodomésticos"
  },
  {
    "value": "109015240",
    "text": "109015240 - Arrendamento mercantil financeiro de equipamentos para diversão e lazer"
  },
  {
    "value": "109015250",
    "text": "109015250 - Arrendamento mercantil financeiro de artigos de cama, mesa e banho"
  },
  {
    "value": "109015290",
    "text": "109015290 - Arrendamento mercantil financeiro de outras mercadorias não classificado em subposições anteriores"
  },
  {
    "value": "109019000",
    "text": "109019000 - Serviços financeiros, exceto bancos de investimento, serviços de seguros e previdência complementar, não classificados em subposições anteriores"
  },
  {
    "value": "109021000",
    "text": "109021000 - Serviços de valoração de ativos"
  },
  {
    "value": "109022000",
    "text": "109022000 - Serviços de subscrição de valores mobiliários"
  },
  {
    "value": "109023000",
    "text": "109023000 - Serviços de fusões e aquisições"
  },
  {
    "value": "109024000",
    "text": "109024000 - Serviços de capital de risco e finanças corporativas"
  },
  {
    "value": "109029000",
    "text": "109029000 - Serviços de banco de investimento não classificados em subposições anteriores"
  },
  {
    "value": "109031100",
    "text": "109031100 - Serviços de seguro de vida"
  },
  {
    "value": "109031200",
    "text": "109031200 - Serviços de previdência complementar aberta"
  },
  {
    "value": "109031300",
    "text": "109031300 - Serviços de previdência complementar fechada"
  },
  {
    "value": "109032100",
    "text": "109032100 - Serviços de seguro saúde"
  },
  {
    "value": "109032200",
    "text": "109032200 - Serviços de seguro de acidentes"
  },
  {
    "value": "109033100",
    "text": "109033100 - Serviços de seguro de veículos rodoviários"
  },
  {
    "value": "109033200",
    "text": "109033200 - Serviços de seguro de veículos e equipamentos para transporte ferroviário, aquaviário e aéreo"
  },
  {
    "value": "109033300",
    "text": "109033300 - Serviços de seguro de cargas"
  },
  {
    "value": "109033400",
    "text": "109033400 - Serviços de seguro de outras propriedades"
  },
  {
    "value": "109033500",
    "text": "109033500 - Serviços de seguro por responsabilidade civil"
  },
  {
    "value": "109033600",
    "text": "109033600 - Serviços de seguro de crédito e de caução"
  },
  {
    "value": "109033700",
    "text": "109033700 - Serviços de seguro de viagem"
  },
  {
    "value": "109033800",
    "text": "109033800 - Serviços de seguro rural"
  },
  {
    "value": "109033900",
    "text": "109033900 - Serviços de outros seguros, excluídos os serviços de resseguro, não classificados em subposições anteriores"
  },
  {
    "value": "109041000",
    "text": "109041000 - Serviços de resseguro de vida"
  },
  {
    "value": "109042100",
    "text": "109042100 - Serviços de resseguro saúde"
  },
  {
    "value": "109042200",
    "text": "109042200 - Serviços de resseguro de acidentes"
  },
  {
    "value": "109043100",
    "text": "109043100 - Serviços de resseguro de veículos rodoviários"
  },
  {
    "value": "109043200",
    "text": "109043200 - Serviços de resseguro de veículos e equipamentos para transporte ferroviário, aquaviário e aéreo"
  },
  {
    "value": "109043300",
    "text": "109043300 - Serviços de resseguro de cargas"
  },
  {
    "value": "109043400",
    "text": "109043400 - Serviços de resseguro de outras propriedades"
  },
  {
    "value": "109043500",
    "text": "109043500 - Serviços de resseguro de responsabilidade civil"
  },
  {
    "value": "109043600",
    "text": "109043600 - Serviços de resseguro de crédito e caução"
  },
  {
    "value": "109043700",
    "text": "109043700 - Serviços de resseguro rural"
  },
  {
    "value": "109043900",
    "text": "109043900 - Serviços de outros resseguros não classificados em subposições anteriores"
  },
  {
    "value": "109051100",
    "text": "109051100 - Serviços de corretagem de títulos"
  },
  {
    "value": "109051200",
    "text": "109051200 - Serviços de corretagem de derivativos e commodities"
  },
  {
    "value": "109051300",
    "text": "109051300 - Serviços de compensação de transações financeiras, inclusive com ativos financeiros (clearinghouse)"
  },
  {
    "value": "109052100",
    "text": "109052100 - Serviços de gestão e administração de carteiras de ativos, exceto fundos de pensão"
  },
  {
    "value": "109052200",
    "text": "109052200 - Serviços de administração fundos de investimento e fundos de pensão"
  },
  {
    "value": "109052300",
    "text": "109052300 - Serviços de gestão e administração de trust"
  },
  {
    "value": "109053000",
    "text": "109053000 - Serviços de guarda e custódia"
  },
  {
    "value": "109054000",
    "text": "109054000 - Serviços relacionados à administração de mercados financeiros"
  },
  {
    "value": "109055000",
    "text": "109055000 - Serviços de consultoria financeira"
  },
  {
    "value": "109056000",
    "text": "109056000 - Serviços de câmbio"
  },
  {
    "value": "109057000",
    "text": "109057000 - Serviços de classificação de risco (rating)"
  },
  {
    "value": "109058000",
    "text": "109058000 - Serviços fiduciários"
  },
  {
    "value": "109059000",
    "text": "109059000 - Serviços auxiliares aos serviços financeiros não classificados em subposições anteriores"
  },
  {
    "value": "109061100",
    "text": "109061100 - Serviços de agenciamento e corretagem de seguros, resseguros e previdência complementar, exceto de seguros saúde"
  },
  {
    "value": "109061200",
    "text": "109061200 - Serviços de corretagem de seguros saúde"
  },
  {
    "value": "109062000",
    "text": "109062000 - Serviços de perícia e avaliação de seguros e resseguros"
  },
  {
    "value": "109063000",
    "text": "109063000 - Serviços atuariais"
  },
  {
    "value": "109064000",
    "text": "109064000 - Serviços de gestão de fundos de previdência complementar"
  },
  {
    "value": "109069000",
    "text": "109069000 - Serviços auxiliares a seguros, resseguros e previdência complementar não classificados em subposições anteriores"
  },
  {
    "value": "109070000",
    "text": "109070000 - Serviços de seguro de recebíveis"
  },
  {
    "value": "109080000",
    "text": "109080000 - Fomento comercial (factoring)"
  },
  {
    "value": "109091000",
    "text": "109091000 - Serviços de holding de patrimônio de empresas subsidiárias"
  },
  {
    "value": "109092000",
    "text": "109092000 - Serviços de holding de valores mobiliários e outros ativos financeiros e fundos e entidades financeiras similares"
  },
  {
    "value": "109101000",
    "text": "109101000 - Serviços de planos privados de assistência à saúde"
  },
  {
    "value": "109102000",
    "text": "109102000 - Serviços de corretagem de planos privados de assistência à saúde"
  },
  {
    "value": "109109000",
    "text": "109109000 - Serviços de planos privados de assistência à saúde e serviços relacionados não classificados em subposições anteriores"
  },
  {
    "value": "109110000",
    "text": "109110000 - Serviços financeiros e serviços relacionados não classificados em posições anteriores"
  },
  {
    "value": "110011100",
    "text": "110011100 - Serviços de administração e locação de imóveis residenciais"
  },
  {
    "value": "110011210",
    "text": "110011210 - Serviços de administração e locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia, rodovia, postes, cabos, dutos e condutos de qualquer natureza"
  },
  {
    "value": "110011290",
    "text": "110011290 - Serviços de administração e locação de outros imóveis não residenciais"
  },
  {
    "value": "110012100",
    "text": "110012100 - Serviços de intermediação na compra e venda de imóveis residenciais"
  },
  {
    "value": "110012200",
    "text": "110012200 - Serviços de intermediação na compra e venda de imóveis não residenciais"
  },
  {
    "value": "110013000",
    "text": "110013000 - Serviços de avaliação de imóveis"
  },
  {
    "value": "110014000",
    "text": "110014000 - Serviços de consultoria imobiliária"
  },
  {
    "value": "110015000",
    "text": "110015000 - Serviços de assessoria de gestão condominial (condomínios, edifícios residenciais e mistos)"
  },
  {
    "value": "110019000",
    "text": "110019000 - Serviços imobiliários não classificados em subposições anteriores"
  },
  {
    "value": "110021000",
    "text": "110021000 - Locação de imóveis residenciais"
  },
  {
    "value": "110022000",
    "text": "110022000 - Locação de imóveis não residenciais"
  },
  {
    "value": "111011100",
    "text": "111011100 - Arrendamento mercantil operacional ou locação de veículos rodoviários automotores para o transporte de até oito passageiros, sem operador"
  },
  {
    "value": "111011200",
    "text": "111011200  - Arrendamento mercantil operacional ou locação de veículos rodoviários automotores para o transporte de cargas, sem operador"
  },
  {
    "value": "111011300",
    "text": "111011300  - Arrendamento mercantil operacional ou locação de veículos e equipamentos de transporte ferroviário, sem operador"
  },
  {
    "value": "111011400",
    "text": "111011400 - Arrendamento mercantil operacional ou locação de outros equipamentos de transporte terrestre, inclusive de veículos de uso misto, sem operador"
  },
  {
    "value": "111011500",
    "text": "111011500 - Arrendamento mercantil operacional ou locação de navios e outras embarcações, sem tripulação"
  },
  {
    "value": "111011600",
    "text": "111011600 - Arrendamento mercantil operacional ou locação de aeronaves, sem tripulação"
  },
  {
    "value": "111011700",
    "text": "111011700 - Arrendamento mercantil operacional ou locação de contêineres"
  },
  {
    "value": "111012000",
    "text": "111012000 - Arrendamento mercantil operacional ou locação de máquinas e equipamentos agrícolas, sem operador"
  },
  {
    "value": "111013000",
    "text": "111013000 - Arrendamento mercantil operacional ou locação de máquinas e equipamentos de construção, sem operador"
  },
  {
    "value": "111014000",
    "text": "111014000 - Arrendamento mercantil operacional ou locação de máquinas e equipamentos para escritórios, exceto computadores, sem operador"
  },
  {
    "value": "111015000",
    "text": "111015000 - Arrendamento mercantil operacional ou locação de computadores, sem operador"
  },
  {
    "value": "111016000",
    "text": "111016000 - Arrendamento mercantil operacional ou locação de equipamentos de telecomunicação, sem operador"
  },
  {
    "value": "111019000",
    "text": "111019000 - Arrendamento mercantil operacional ou locação de máquinas e equipamentos, sem operador, não classificado em subposições anteriores"
  },
  {
    "value": "111021000",
    "text": "111021000 - Arrendamento mercantil operacional ou locação de televisão e outros eletroeletrônicos, bem como seus acessórios"
  },
  {
    "value": "111022000",
    "text": "111022000 - Arrendamento mercantil operacional ou locação de mídias gravadas"
  },
  {
    "value": "111023000",
    "text": "111023000 - Arrendamento mercantil operacional ou locação de móveis e eletrodomésticos"
  },
  {
    "value": "111024000",
    "text": "111024000 - Arrendamento mercantil operacional ou locação de equipamentos para diversão e lazer"
  },
  {
    "value": "111025000",
    "text": "111025000 - Arrendamento mercantil operacional ou locação de artigos de cama, mesa e banho"
  },
  {
    "value": "111026000",
    "text": "111026000 - Arrendamento mercantil operacional ou locação de roupas e calçados"
  },
  {
    "value": "111029000",
    "text": "111029000 - Arrendamento mercantil operacional ou locação de outras mercadorias não classificado em subposições anteriores"
  },
  {
    "value": "111031000",
    "text": "111031000 - Licenciamento de direitos de obras literárias"
  },
  {
    "value": "111032100",
    "text": "111032100 - Licenciamento de direitos de produção, distribuição ou comercialização de programas de computador (software)"
  },
  {
    "value": "111032200",
    "text": "111032200 - Licenciamento de direitos de uso de programas de computador (software)"
  },
  {
    "value": "111032300",
    "text": "111032300 - Licenciamento de direitos sobre bancos de dados"
  },
  {
    "value": "111032900",
    "text": "111032900 - Licenciamento de direitos sobre programas de computador (software) e bancos de dados não classificado em subposições anteriores"
  },
  {
    "value": "111033100",
    "text": "111033100 - Licenciamento de direitos de autor de obras cinematográficas"
  },
  {
    "value": "111033200",
    "text": "111033200 - Licenciamento de direitos de autor de obras jornalísticas"
  },
  {
    "value": "111033300",
    "text": "111033300 - Licenciamento de direitos de autor de obras publicitárias"
  },
  {
    "value": "111033400",
    "text": "111033400 - Licenciamento de direitos conexos de artistas intérpretes ou executantes em obras audiovisuais"
  },
  {
    "value": "111033500",
    "text": "111033500 - Licenciamento de direitos conexos de produtores de obras audiovisuais"
  },
  {
    "value": "111033610",
    "text": "111033610 - Licenciamento de direitos de obras audiovisuais sobre transmissões de eventos esportivos"
  },
  {
    "value": "111033620",
    "text": "111033620 - Licenciamento de direitos de obras audiovisuais sobre transmissões de programas televisivos"
  },
  {
    "value": "111033690",
    "text": "111033690 - Licenciamento de direitos de obras audiovisuais sobre outras transmissões televisivas"
  },
  {
    "value": "111033900",
    "text": "111033900 - Licenciamento de direitos de obras audiovisuais não classificado em subposições anteriores"
  },
  {
    "value": "111034100",
    "text": "111034100 - Licenciamento de direitos de autor de obras musicais ou literomusicais"
  },
  {
    "value": "111034200",
    "text": "111034200 - Licenciamento de direitos conexos de artistas intérpretes ou executantes"
  },
  {
    "value": "111034300",
    "text": "111034300 - Licenciamento de direitos conexos de produtores de fonogramas"
  },
  {
    "value": "111035000",
    "text": "111035000 - Licenciamento de direitos relacionados à radiodifusão"
  },
  {
    "value": "111039000",
    "text": "111039000  - Licenciamento de direitos de autor e de direitos conexos não classificado em subposições anteriores"
  },
  {
    "value": "111041000",
    "text": "111041000 - Licenciamento de direitos sobre patentes"
  },
  {
    "value": "111042000",
    "text": "111042000 - Licenciamento de direitos sobre marcas"
  },
  {
    "value": "111043000",
    "text": "111043000 - Licenciamento de direitos sobre desenho industrial"
  },
  {
    "value": "111049000",
    "text": "111049000 - Licenciamento de direitos sobre a propriedade industrial não classificado em subposições anteriores"
  },
  {
    "value": "111051000",
    "text": "111051000 - Licenciamento de direitos sobre cultivares"
  },
  {
    "value": "111052000",
    "text": "111052000 - Licenciamento de direitos sobre topografias de circuitos integrados"
  },
  {
    "value": "111053000",
    "text": "111053000 - Licenciamento de direitos relativos à informação não divulgada"
  },
  {
    "value": "111054100",
    "text": "111054100 - Exploração de recursos vegetais, inclusive florestais"
  },
  {
    "value": "111054200",
    "text": "111054200 - Exploração de recursos minerais"
  },
  {
    "value": "111055100",
    "text": "111055100 - Licenciamento de direitos sobre conhecimento tradicional associado a recursos genéticos"
  },
  {
    "value": "111055900",
    "text": "111055900 - Licenciamento de direitos sobre conhecimento tradicional não classificado em subposições anteriores"
  },
  {
    "value": "111056000",
    "text": "111056000 - Licenciamento de direitos relativos ao acesso a recursos genéticos, exceto os decorrentes do conhecimento tradicional"
  },
  {
    "value": "111057000",
    "text": "111057000 - Licenciamento de direitos sobre informações relativas à experiência adquirida no setor industrial, comercial ou científico (know-how)"
  },
  {
    "value": "111059000",
    "text": "111059000 - Licenciamento de outros direitos não classificado em subposições anteriores"
  },
  {
    "value": "111061000",
    "text": "111061000 - Cessão temporária de direitos de obras literárias"
  },
  {
    "value": "111062000",
    "text": "111062000 - Cessão temporária de direitos sobre programas de computador (software)"
  },
  {
    "value": "111063100",
    "text": "111063100 - Cessão temporária de direitos de autor de obras cinematográficas"
  },
  {
    "value": "111063200",
    "text": "111063200 - Cessão temporária de direitos de autor de obras jornalísticas"
  },
  {
    "value": "111063300",
    "text": "111063300 - Cessão temporária de direitos de autor de obras publicitárias"
  },
  {
    "value": "111063400",
    "text": "111063400 - Cessão temporária de direitos conexos de artistas intérpretes ou executantes em obras audiovisuais"
  },
  {
    "value": "111063500",
    "text": "111063500 - Cessão temporária de direitos conexos de produtores de obras audiovisuais"
  },
  {
    "value": "111063610",
    "text": "111063610 - Cessão temporária de direitos de obras audiovisuais sobre transmissões de eventos esportivos"
  },
  {
    "value": "111063620",
    "text": "111063620 - Cessão temporária de direitos de obras audiovisuais sobre transmissões de programas televisivos"
  },
  {
    "value": "111063690",
    "text": "111063690 - Cessão temporária de direitos de obras audiovisuais sobre outras transmissões televisivas"
  },
  {
    "value": "111063900",
    "text": "111063900 - Cessão temporária de direitos de obras audiovisuais não classificada em subposições anteriores"
  },
  {
    "value": "111064100",
    "text": "111064100 - Cessão temporária de direitos de autor de obras musicais e literomusicais"
  },
  {
    "value": "111064200",
    "text": "111064200 - Cessão temporária de direitos conexos de artistas intérpretes ou executantes"
  },
  {
    "value": "111064300",
    "text": "111064300 - Cessão temporária de direitos conexos de produtores de fonogramas"
  },
  {
    "value": "111065000",
    "text": "111065000 - Cessão temporária de direitos relacionados à radiodifusão"
  },
  {
    "value": "111069000",
    "text": "111069000 - Cessão temporária de direitos de autor e de direitos conexos não classificada em subposições anteriores"
  },
  {
    "value": "111071000",
    "text": "111071000 - Cessão definitiva de direitos de obras literárias"
  },
  {
    "value": "111072000",
    "text": "111072000 - Cessão definitiva de direitos sobre programas de computador (software)"
  },
  {
    "value": "111073100",
    "text": "111073100 - Cessão definitiva de direitos de obras cinematográficas"
  },
  {
    "value": "111073200",
    "text": "111073200 - Cessão definitiva de direitos de obras jornalísticas"
  },
  {
    "value": "111073300",
    "text": "111073300 - Cessão definitiva de direitos de obras publicitárias"
  },
  {
    "value": "111073900",
    "text": "111073900 - Cessão definitiva de direitos de obras audiovisuais não classificada em subposições anteriores"
  },
  {
    "value": "111074000",
    "text": "111074000 - Cessão definitiva de direitos de obras musicais e de fonogramas"
  },
  {
    "value": "111075000",
    "text": "111075000 - Cessão definitiva de direitos relacionados à radiodifusão"
  },
  {
    "value": "111079000",
    "text": "111079000 - Cessão definitiva de direitos de autor e de direitos conexos não classificada em subposições anteriores"
  },
  {
    "value": "111081000",
    "text": "111081000 - Cessão definitiva de direitos sobre patentes"
  },
  {
    "value": "111082000",
    "text": "111082000 - Cessão definitiva de direitos sobre marcas"
  },
  {
    "value": "111083000",
    "text": "111083000 - Cessão definitiva de direitos sobre desenho industrial"
  },
  {
    "value": "111089000",
    "text": "111089000 - Cessão definitiva de direitos sobre a propriedade industrial não classificada em subposições anteriores"
  },
  {
    "value": "111091000",
    "text": "111091000 - Cessão definitiva de direitos sobre cultivares"
  },
  {
    "value": "111092000",
    "text": "111092000 - Cessão definitiva de direitos sobre topografias de circuitos integrados"
  },
  {
    "value": "111093000",
    "text": "111093000 - Cessão definitiva de direitos relativos à informação não divulgada"
  },
  {
    "value": "111099000",
    "text": "111099000 - Cessão definitiva de outros direitos não classificada em subposições anteriores"
  },
  {
    "value": "111100000",
    "text": "111100000 - Franquia"
  },
  {
    "value": "112011100",
    "text": "112011100 - Serviços de pesquisa e desenvolvimento em ciências físicas"
  },
  {
    "value": "112011200",
    "text": "112011200 - Serviços de pesquisa e desenvolvimento em química e biologia"
  },
  {
    "value": "112011900",
    "text": "112011900 - Serviços de pesquisa e desenvolvimento em ciências naturais não classificadas em subposições anteriores"
  },
  {
    "value": "112012000",
    "text": "112012000 - Serviços de pesquisa e desenvolvimento em biotecnologia"
  },
  {
    "value": "112013100",
    "text": "112013100 - Serviços de pesquisa e desenvolvimento em Tecnologia da Informação e Comunicação (TIC)"
  },
  {
    "value": "112013200",
    "text": "112013200 - Serviços de pesquisa e desenvolvimento em nanotecnologia"
  },
  {
    "value": "112013300",
    "text": "112013300 - Serviços de pesquisa e desenvolvimento em engenharia e tecnologia nucleares"
  },
  {
    "value": "112013400",
    "text": "112013400 - Serviços de pesquisa e desenvolvimento em engenharia e tecnologia em micro-ondas de potência"
  },
  {
    "value": "112013900",
    "text": "112013900 - Serviços de pesquisa e desenvolvimento em engenharia e tecnologia não classificados em subposições anteriores"
  },
  {
    "value": "112014000",
    "text": "112014000 - Serviços de pesquisa e desenvolvimento em ciências médicas, odontológicas e farmacêuticas"
  },
  {
    "value": "112015000",
    "text": "112015000 - Serviços de pesquisa e desenvolvimento em ciências agrárias"
  },
  {
    "value": "112019000",
    "text": "112019000 - Serviços de pesquisa e desenvolvimento em ciências, engenharia e tecnologia não classificados em subposições anteriores"
  },
  {
    "value": "112021000",
    "text": "112021000 - Serviços de pesquisa e desenvolvimento em psicologia"
  },
  {
    "value": "112022000",
    "text": "112022000 - Serviços de pesquisa e desenvolvimento em ciências econômicas"
  },
  {
    "value": "112023000",
    "text": "112023000 - Serviços de pesquisa e desenvolvimento em direito"
  },
  {
    "value": "112024000",
    "text": "112024000 - Serviços de pesquisa e desenvolvimento em línguas e literatura"
  },
  {
    "value": "112029000",
    "text": "112029000 - Serviços de pesquisa e desenvolvimento em ciências sociais e humanidades não classificadas em subposições anteriores"
  },
  {
    "value": "112030000",
    "text": "112030000 - Serviços de pesquisa e desenvolvimento interdisciplinar"
  },
  {
    "value": "113011000",
    "text": "113011000 - Serviços de representação e consultoria jurídica criminal"
  },
  {
    "value": "113012000",
    "text": "113012000 - Serviços de representação e consultoria jurídica em outras áreas do direito, exceto consultoria tributária"
  },
  {
    "value": "113013000",
    "text": "113013000 - Serviços de documentação e certificação, exceto os serviços notariais e de registro"
  },
  {
    "value": "113014000",
    "text": "113014000 - Serviços de arbitragem, conciliação e mediação"
  },
  {
    "value": "113019000",
    "text": "113019000 - Serviços jurídicos não classificados em subposições anteriores"
  },
  {
    "value": "113021100",
    "text": "113021100 - Serviços de auditoria contábil"
  },
  {
    "value": "113021900",
    "text": "113021900 - Serviços de auditoria não classificados em subposições anteriores"
  },
  {
    "value": "113022100",
    "text": "113022100 - Serviços de contabilidade"
  },
  {
    "value": "113022200",
    "text": "113022200 - Serviços de escrituração mercantil"
  },
  {
    "value": "113022300",
    "text": "113022300 - Serviços de folha de pagamento"
  },
  {
    "value": "113031000",
    "text": "113031000 - Serviços de consultoria tributária para pessoas jurídicas"
  },
  {
    "value": "113032000",
    "text": "113032000 - Serviços de consultoria tributária para pessoas físicas"
  },
  {
    "value": "113040000",
    "text": "113040000 - Serviços notariais e de registro"
  },
  {
    "value": "114011100",
    "text": "114011100 - Serviços de consultoria em gestão estratégica"
  },
  {
    "value": "114011200",
    "text": "114011200 - Serviços de consultoria em gestão financeira"
  },
  {
    "value": "114011300",
    "text": "114011300 - Serviços de consultoria em gestão de recursos humanos"
  },
  {
    "value": "114011400",
    "text": "114011400 - Serviços de consultoria em gestão de marketing"
  },
  {
    "value": "114011500",
    "text": "114011500 - Serviços de consultoria em gestão operacional"
  },
  {
    "value": "114011600",
    "text": "114011600 - Serviços de consultoria em gestão energética"
  },
  {
    "value": "114011700",
    "text": "114011700 - Serviços de consultoria em gestão de cadeia logística"
  },
  {
    "value": "114011800",
    "text": "114011800 - Serviços de consultoria em gestão hospitalar"
  },
  {
    "value": "114011900",
    "text": "114011900 - Serviços de consultoria em gestão empresarial não classificados em subposições anteriores"
  },
  {
    "value": "114012100",
    "text": "114012100 - Serviços de gestão em processos de negócios"
  },
  {
    "value": "114012200",
    "text": "114012200 - Serviços de gestão hospitalar"
  },
  {
    "value": "114012900",
    "text": "114012900 - Serviços de gestão não classificados em subposições anteriores"
  },
  {
    "value": "114013100",
    "text": "114013100 - Serviços de assessoria de imprensa"
  },
  {
    "value": "114013200",
    "text": "114013200 - Serviços de relações públicas"
  },
  {
    "value": "114013900",
    "text": "114013900 - Serviços de assessoria empresarial não classificados em subposições anteriores"
  },
  {
    "value": "114021100",
    "text": "114021100 - Serviços de consultoria em arquitetura"
  },
  {
    "value": "114021200",
    "text": "114021200 - Serviços de arquitetura para projetos de construções residenciais"
  },
  {
    "value": "114021300",
    "text": "114021300 - Serviços de arquitetura para projetos de construções não residenciais"
  },
  {
    "value": "114021400",
    "text": "114021400 - Serviços de arquitetura para restauração de prédios históricos"
  },
  {
    "value": "114021500",
    "text": "114021500 - Serviços de arquitetura relativos ao acompanhamento e fiscalização da execução de projetos arquitetônicos e urbanísticos"
  },
  {
    "value": "114022100",
    "text": "114022100 - Serviços de planejamento urbano"
  },
  {
    "value": "114022200",
    "text": "114022200 - Serviços de planejamento de áreas rurais"
  },
  {
    "value": "114023100",
    "text": "114023100 - Serviços de consultoria em paisagismo"
  },
  {
    "value": "114023200",
    "text": "114023200 - Serviços de paisagismo, exceto consultoria"
  },
  {
    "value": "114029000",
    "text": "114029000 - Serviços de arquitetura, de planejamento urbano e de áreas rurais e de paisagismo não classificados em subposições anteriores"
  },
  {
    "value": "114031000",
    "text": "114031000 - Serviços de consultoria em engenharia"
  },
  {
    "value": "114032110",
    "text": "114032110 - Serviços de engenharia para projetos de construção residencial"
  },
  {
    "value": "114032120",
    "text": "114032120 - Serviços de engenharia para projetos de construção não-residencial"
  },
  {
    "value": "114032211",
    "text": "114032211 - Serviços de engenharia para projetos de exploração de minerais"
  },
  {
    "value": "114032212",
    "text": "114032212 - Serviços de engenharia para projetos de exploração de petróleo e gás"
  },
  {
    "value": "114032213",
    "text": "114032213 - Serviços de engenharia para projetos de refino de petróleo e petroquímica"
  },
  {
    "value": "114032214",
    "text": "114032214 - Serviços de engenharia para projetos de unidades de produção de biocombustíveis"
  },
  {
    "value": "114032221",
    "text": "114032221  - Serviços de engenharia para projetos de veículos terrestres"
  },
  {
    "value": "114032222",
    "text": "114032222 - Serviços de engenharia para projetos de embarcações"
  },
  {
    "value": "114032223",
    "text": "114032223 - Serviços de engenharia para projetos de veículos aéreos e aeroespaciais"
  },
  {
    "value": "114032290",
    "text": "114032290 - Serviços de engenharia para outros projetos industriais e de fabricação, exceto para projetos de energia"
  },
  {
    "value": "114032300",
    "text": "114032300 - Serviços de engenharia para projetos de infraestrutura de transportes"
  },
  {
    "value": "114032400",
    "text": "114032400 - Serviços de engenharia para projetos de energia"
  },
  {
    "value": "114032500",
    "text": "114032500 - Serviços de engenharia para projetos de telecomunicações, radiodifusão e televisão"
  },
  {
    "value": "114032600",
    "text": "114032600 - Serviços de engenharia para projetos de gerenciamento de resíduos (perigosos e não perigosos)"
  },
  {
    "value": "114032700",
    "text": "114032700 - Serviços de engenharia para projetos de distribuição de água e rede de esgoto"
  },
  {
    "value": "114032900",
    "text": "114032900 - Serviços de engenharia para outros projetos"
  },
  {
    "value": "114033000",
    "text": "114033000 - Serviços de gerenciamento de projetos de construção"
  },
  {
    "value": "114039000",
    "text": "114039000 - Serviços de engenharia não classificados em subposições anteriores"
  },
  {
    "value": "114041100",
    "text": "114041100 - Serviços de consultoria geológica e geofísica"
  },
  {
    "value": "114041200",
    "text": "114041200 - Serviços geofísicos"
  },
  {
    "value": "114041300",
    "text": "114041300 - Serviços geoquímicos"
  },
  {
    "value": "114041400",
    "text": "114041400 - Serviços de informações para avaliação e exploração de recursos naturais"
  },
  {
    "value": "114041900",
    "text": "114041900 - Serviços geológicos, geofísicos e outros de prospecção não classificados em subposições anteriores"
  },
  {
    "value": "114042100",
    "text": "114042100 - Serviços topográficos"
  },
  {
    "value": "114042200",
    "text": "114042200 - Serviços cartográficos"
  },
  {
    "value": "114043000",
    "text": "114043000 - Serviços meteorológicos e de previsão do tempo"
  },
  {
    "value": "114044100",
    "text": "114044100 - Serviços de análise e de exames técnicos sobre pureza e composição"
  },
  {
    "value": "114044200",
    "text": "114044200 - Serviços de análise e de exames técnicos de propriedades físicas"
  },
  {
    "value": "114044300",
    "text": "114044300 - Serviços de análise e de exames técnicos de sistemas elétricos e mecânicos"
  },
  {
    "value": "114044400",
    "text": "114044400 - Serviços de inspeção técnica de veículos de transporte rodoviário"
  },
  {
    "value": "114044900",
    "text": "114044900 - Serviços de análise e exames técnicos não classificados em subposições anteriores"
  },
  {
    "value": "114051100",
    "text": "114051100 - Serviços hospitalares, com ou sem internação, para animais domésticos"
  },
  {
    "value": "114051200",
    "text": "114051200 - Serviços de atendimento, assistência ou tratamento para animais domésticos"
  },
  {
    "value": "114052100",
    "text": "114052100 - Serviços hospitalares, com ou sem internação, para animais de corte"
  },
  {
    "value": "114052200",
    "text": "114052200 - Serviços de atendimento, assistência ou tratamento para animais de corte"
  },
  {
    "value": "114053000",
    "text": "114053000 - Serviços funerários, de cremação e de embalsamamento de animais"
  },
  {
    "value": "114054000",
    "text": "114054000 - Serviços de bancos de órgãos, sangue, sêmen, tecidos, óvulos e outros materiais biológicos"
  },
  {
    "value": "114055000",
    "text": "114055000 - Planos de atendimento e assistência médico-veterinária"
  },
  {
    "value": "114056000",
    "text": "114056000 - Serviços de guarda, adestramento, embelezamento e alojamento"
  },
  {
    "value": "114059000",
    "text": "114059000 - Serviços veterinários não classificados em subposições anteriores"
  },
  {
    "value": "114061100",
    "text": "114061100 - Serviços de campanhas publicitárias"
  },
  {
    "value": "114061200",
    "text": "114061200 - Serviços de marketing direto e mala direta"
  },
  {
    "value": "114061900",
    "text": "114061900 - Serviços de propaganda não classificados em subposições anteriores"
  },
  {
    "value": "114062000",
    "text": "114062000 - Aquisição ou venda de espaço ou tempo para propaganda, sob comissão"
  },
  {
    "value": "114063100",
    "text": "114063100 - Venda de espaço para propaganda em mídia impressa, exceto sob comissão"
  },
  {
    "value": "114063200",
    "text": "114063200 - Venda de tempo para propaganda em rádio e televisão, exceto sob comissão"
  },
  {
    "value": "114063300",
    "text": "114063300 - Venda de espaço para propaganda na rede mundial de computadores, exceto sob comissão"
  },
  {
    "value": "114063400",
    "text": "114063400 - Venda de espaço para propaganda em mídia exterior, exceto sob comissão"
  },
  {
    "value": "114063900",
    "text": "114063900 - Venda de espaço ou tempo para propaganda, exceto sob comissão, não classificados em subposições anteriores"
  },
  {
    "value": "114070000",
    "text": "114070000 - Pesquisas de mercado e serviços de pesquisa de opinião pública"
  },
  {
    "value": "114081100",
    "text": "114081100 - Serviços fotográficos de retratos"
  },
  {
    "value": "114081200",
    "text": "114081200 - Serviços fotográficos e videográficos para propaganda"
  },
  {
    "value": "114081300",
    "text": "114081300 - Serviços fotográficos e videográficos de eventos"
  },
  {
    "value": "114081400",
    "text": "114081400 - Serviços fotográficos especiais"
  },
  {
    "value": "114081500",
    "text": "114081500  - Serviços de restauração e retoque de fotografias"
  },
  {
    "value": "114081900",
    "text": "114081900 - Serviços fotográficos e videográficos não classificados em subposições anteriores"
  },
  {
    "value": "114082000",
    "text": "114082000 - Serviços de processamento de fotografias"
  },
  {
    "value": "114091100",
    "text": "114091100 - Serviços de design de interiores para espaços comerciais e públicos"
  },
  {
    "value": "114091200",
    "text": "114091200 - Serviços de design de interiores para espaços residenciais"
  },
  {
    "value": "114092100",
    "text": "114092100 - Serviços de desenho industrial de embalagens, expositores de loja e objetos promocionais para comunicação e vendas"
  },
  {
    "value": "114092200",
    "text": "114092200 - Serviços de desenho industrial de produtos, utensílios, equipamentos, vestuário, calçados, ornamentos, joias e objetos pessoais"
  },
  {
    "value": "114092300",
    "text": "114092300 - Serviços de desenho industrial de máquinas, equipamentos, acessórios e objetos de uso industrial de qualquer natureza"
  },
  {
    "value": "114092400",
    "text": "114092400 - Serviços de desenho industrial de mobiliários e itens de decoração"
  },
  {
    "value": "114092500",
    "text": "114092500 - Serviços de desenho industrial de utensílios e equipamentos eletrodomésticos e eletroeletrônicos"
  },
  {
    "value": "114092900",
    "text": "114092900  - Serviços de desenho industrial não classificados em subposições anteriores"
  },
  {
    "value": "114093000",
    "text": "114093000 - Serviços de design de marcas, imagens, objetos gráficos e digitais"
  },
  {
    "value": "114099000",
    "text": "114099000 - Serviços especializados de design não classificados em subposições anteriores"
  },
  {
    "value": "114101000",
    "text": "114101000 - Serviços de consultoria ambiental"
  },
  {
    "value": "114109000",
    "text": "114109000 - Serviços de consultoria técnica e científica não classificados em subposições anteriores"
  },
  {
    "value": "114110000",
    "text": "114110000 - Serviços de tradução e de intérpretes"
  },
  {
    "value": "114120000",
    "text": "114120000 - Serviços para registros de marcas comerciais e de franquias empresariais, exceto as licenças de uso de direito"
  },
  {
    "value": "114130000",
    "text": "114130000  - Serviços de prospecção de clientes"
  },
  {
    "value": "114140000",
    "text": "114140000  - Serviços de prospecção de fornecedores"
  },
  {
    "value": "114150000",
    "text": "114150000 - Serviços profissionais, técnicos e gerenciais não classificados em posições anteriores"
  },
  {
    "value": "115011000",
    "text": "115011000  - Serviços de consultoria em tecnologia da informação (TI)"
  },
  {
    "value": "115012000",
    "text": "115012000  - Serviços de segurança em tecnologia da informação (TI)"
  },
  {
    "value": "115013000",
    "text": "115013000  - Serviços de suporte em tecnologia da informação (TI)"
  },
  {
    "value": "115021000",
    "text": "115021000  - Serviços de projeto, desenvolvimento e instalação de aplicativos e programas não personalizados (não customizados)"
  },
  {
    "value": "115022000",
    "text": "115022000  - Serviços de projeto e desenvolvimento, adaptação e instalação de aplicativos personalizados (customizados)"
  },
  {
    "value": "115023000",
    "text": "115023000  - Serviços de projeto e desenvolvimento de estruturas e conteúdo de páginas eletrônicas"
  },
  {
    "value": "115024000",
    "text": "115024000  - Serviços de projeto e desenvolvimento de estruturas e conteúdo de bancos de dados"
  },
  {
    "value": "115025000",
    "text": "115025000  - Serviços de integração de sistemas em tecnologia da informação (TI)"
  },
  {
    "value": "115029000",
    "text": "115029000 - Serviços de projeto e desenvolvimento de aplicativos e programas em tecnologia da informação (TI) não classificados em subposições anteriores"
  },
  {
    "value": "115030000",
    "text": "115030000  - Serviços de projeto e desenvolvimento de redes em tecnologia da informação (TI)"
  },
  {
    "value": "115040000",
    "text": "115040000  - Serviços de projeto e desenvolvimento de topografias de circuitos integrados"
  },
  {
    "value": "115050000",
    "text": "115050000  - Serviços de projeto de circuitos integrados"
  },
  {
    "value": "115061000",
    "text": "115061000  - Serviços de hospedagem de sítios na rede mundial de computadores"
  },
  {
    "value": "115062100",
    "text": "115062100 - Serviços de hospedagem de aplicativos e programas software como serviço (SaaS)"
  },
  {
    "value": "115062200",
    "text": "115062200 - Serviços de fornecimento de infraestrutura como serviço (IaaS)"
  },
  {
    "value": "115062300",
    "text": "115062300 - Serviços de fornecimento de plataformas como serviço (PaaS)"
  },
  {
    "value": "115062900",
    "text": "115062900 - Serviços de hospedagem de aplicativos e programas não classificados em subposições anteriores"
  },
  {
    "value": "115069000",
    "text": "115069000  - Serviços de hospedagem e de disponibilização de infraestrutura em tecnologia da informação (TI) não classificados em subposições anteriores"
  },
  {
    "value": "115071000",
    "text": "115071000  - Serviços de gerenciamento de redes"
  },
  {
    "value": "115072000",
    "text": "115072000  - Serviços de gerenciamento de sistemas computacionais"
  },
  {
    "value": "115079000",
    "text": "115079000  - Serviços de gerenciamento de infraestrutura em tecnologia da informação (TI) não classificados em subposições anteriores"
  },
  {
    "value": "115080000",
    "text": "115080000  - Serviços de manutenção de aplicativos e programas"
  },
  {
    "value": "115090000",
    "text": "115090000  - Serviços de processamento de dados"
  },
  {
    "value": "115100000",
    "text": "115100000  - Serviços em tecnologia da informação (TI) não classificados em subposições anteriores"
  },
  {
    "value": "117011100",
    "text": "117011100 - Serviços de interconexão pelo uso da rede fixa"
  },
  {
    "value": "117011200",
    "text": "117011200 - Serviços de interconexão pelo uso de rede móvel"
  },
  {
    "value": "117011900",
    "text": "117011900 - Serviços de operadoras não classificados em subposições anteriores"
  },
  {
    "value": "117012100",
    "text": "117012100 - Serviços de chamadas de telecomunicações fixos comutados"
  },
  {
    "value": "117012900",
    "text": "117012900 - Serviços de telecomunicações fixos não classificados em subposições anteriores"
  },
  {
    "value": "117013100",
    "text": "117013100 - Serviços de voz nas telecomunicações móveis"
  },
  {
    "value": "117013200",
    "text": "117013200 - Serviços de texto nas telecomunicações móveis"
  },
  {
    "value": "117013300",
    "text": "117013300 - Serviços de transmissão de dados nas telecomunicações móveis, exceto serviços de texto"
  },
  {
    "value": "117013400",
    "text": "117013400 - Serviços de telecomunicações móveis para usuários visitantes (roaming)"
  },
  {
    "value": "117014000",
    "text": "117014000 - Serviços de redes privadas"
  },
  {
    "value": "117015100",
    "text": "117015100 - Serviços de transmissão de dados local, nacional ou internacional"
  },
  {
    "value": "117015200",
    "text": "117015200 - Serviços de exploração de linha dedicada local, nacional ou internacional"
  },
  {
    "value": "117019000",
    "text": "117019000 - Outros serviços de telecomunicações, exceto pela rede mundial de computadores, não classificados em subposições anteriores"
  },
  {
    "value": "117021000",
    "text": "117021000 - Serviços de fornecimento de infraestrutura de acesso (backbone) à rede mundial de computadores"
  },
  {
    "value": "117022100",
    "text": "117022100 - Serviços de acesso à rede mundial de computadores por banda estreita"
  },
  {
    "value": "117022200",
    "text": "117022200 - Serviços de acesso à rede mundial de computadores por banda larga"
  },
  {
    "value": "117029000",
    "text": "117029000 - Serviços de telecomunicações pela rede mundial de computadores não classificados em subposições anteriores"
  },
  {
    "value": "117031000",
    "text": "117031000 - Serviços de oferta de livros, jornais, periódicos, diretórios e malas diretas de acesso imediato (on-line)"
  },
  {
    "value": "117032100",
    "text": "117032100 - Serviços de oferta de áudio para download"
  },
  {
    "value": "117032200",
    "text": "117032200 - Serviços de oferta de áudio de conteúdo contínuo (streaming)"
  },
  {
    "value": "117033100",
    "text": "117033100 - Serviços de oferta de arquivos contendo filmes e vídeos para download"
  },
  {
    "value": "117033200",
    "text": "117033200 - Serviços de oferta de filmes e vídeos de conteúdo contínuo (streaming)"
  },
  {
    "value": "117039100",
    "text": "117039100 - Serviços de oferta de jogos e games de acesso imediato (on-line)"
  },
  {
    "value": "117039200",
    "text": "117039200 - Serviços de oferta de conteúdo de portais de busca na rede mundial de computadores"
  },
  {
    "value": "117039900",
    "text": "117039900 - Serviços de oferta de outros conteúdos de acesso imediato (on-line) não classificados em subposições anteriores"
  },
  {
    "value": "117041000",
    "text": "117041000 - Serviços de agências de notícias para jornais e periódicos"
  },
  {
    "value": "117042000",
    "text": "117042000 - Serviços de agências de notícias para mídia audiovisual"
  },
  {
    "value": "117051000",
    "text": "117051000 - Serviços de biblioteca"
  },
  {
    "value": "117052000",
    "text": "117052000 - Serviços de arquivo"
  },
  {
    "value": "117061100",
    "text": "117061100 - Serviços de programação dos canais de rádio"
  },
  {
    "value": "117061200",
    "text": "117061200 - Serviços de programação dos canais de televisão"
  },
  {
    "value": "117062100",
    "text": "117062100 - Serviços de transmissão de sinais, sons e imagens de rádio e televisão, aberta ou por assinatura"
  },
  {
    "value": "117062200",
    "text": "117062200 - Serviços de distribuição de pacotes básicos de programação de televisão por assinatura"
  },
  {
    "value": "117062300",
    "text": "117062300 - Serviços de distribuição de pacotes de programação adicional de televisão por assinatura"
  },
  {
    "value": "117062400",
    "text": "117062400 - Serviços de distribuição de programas de televisão por assinatura, na modalidade pague por exibição (pay-per-view)"
  },
  {
    "value": "117069000",
    "text": "117069000 - Serviços de difusão, programação e distribuição de programas de rádio e televisão não classificados em subposições anteriores"
  },
  {
    "value": "118011100",
    "text": "118011100 - Serviço de recrutamento e seleção de profissionais executivos"
  },
  {
    "value": "118011200",
    "text": "118011200 - Serviço de recrutamento e seleção de profissionais, exceto executivos"
  },
  {
    "value": "118012100",
    "text": "118012100  - Serviços de fornecimento de mão de obra terceirizada, exceto temporária"
  },
  {
    "value": "118012200",
    "text": "118012200  - Serviços de fornecimento de mão de obra temporária"
  },
  {
    "value": "118012900",
    "text": "118012900 - Serviços de fornecimento de mão de obra não classificados em subposições anteriores"
  },
  {
    "value": "118021000",
    "text": "118021000  - Serviços de investigação"
  },
  {
    "value": "118022000",
    "text": "118022000  - Serviços de consultoria em segurança"
  },
  {
    "value": "118023000",
    "text": "118023000  - Serviços de sistemas de segurança"
  },
  {
    "value": "118024000",
    "text": "118024000  - Serviços de carro-forte"
  },
  {
    "value": "118025000",
    "text": "118025000  - Serviços de guarda e escolta armada"
  },
  {
    "value": "118029000",
    "text": "118029000  - Serviços de segurança não classificados em subposições anteriores"
  },
  {
    "value": "118031000",
    "text": "118031000  - Serviços gerais de limpeza"
  },
  {
    "value": "118032100",
    "text": "118032100  - Serviços de desinfecção e extermínio de pragas"
  },
  {
    "value": "118032200",
    "text": "118032200 - Serviços de limpeza de janelas"
  },
  {
    "value": "118032900",
    "text": "118032900  - Serviços especializados de limpeza não classificados em subposições anteriores"
  },
  {
    "value": "118040000",
    "text": "118040000 - Serviços de acondicionamento e empacotamento"
  },
  {
    "value": "118051100",
    "text": "118051100  - Serviços de reservas para transporte aéreo de passageiros"
  },
  {
    "value": "118051200",
    "text": "118051200 - Serviços de reservas para transporte ferroviário de passageiros"
  },
  {
    "value": "118051300",
    "text": "118051300 - Serviços de reservas para transporte rodoviário de passageiros"
  },
  {
    "value": "118051400",
    "text": "118051400 - Serviços de reservas de carros de aluguel"
  },
  {
    "value": "118051900",
    "text": "118051900  - Serviços de reservas para transporte de passageiros não classificados em subposições anteriores"
  },
  {
    "value": "118052100",
    "text": "118052100  - Serviços de reservas de hospedagem, exceto em unidades compartilhadas"
  },
  {
    "value": "118052200",
    "text": "118052200 - Serviços de reservas e intercâmbio de unidades compartilhadas (time-share)"
  },
  {
    "value": "118052300",
    "text": "118052300  - Serviços de reservas em cruzeiros"
  },
  {
    "value": "118052400",
    "text": "118052400  - Serviços de reservas de pacotes turísticos"
  },
  {
    "value": "118053100",
    "text": "118053100 - Serviços de reservas para centros de convenções, centros de congressos e salas de exposições"
  },
  {
    "value": "118053200",
    "text": "118053200 - Serviços de reservas de ingressos para eventos de entretenimento e recreativos"
  },
  {
    "value": "118053900",
    "text": "118053900 - Serviços de reservas não classificados em subposições anteriores"
  },
  {
    "value": "118054000",
    "text": "118054000  - Serviços de operadoras de turismo"
  },
  {
    "value": "118055000",
    "text": "118055000  - Serviços de guias turísticos"
  },
  {
    "value": "118056100",
    "text": "118056100  - Serviços de promoção turística"
  },
  {
    "value": "118056200",
    "text": "118056200  - Serviços de informação a visitantes"
  },
  {
    "value": "118061000",
    "text": "118061000  - Serviços de informação cadastral e análise de crédito"
  },
  {
    "value": "118062000",
    "text": "118062000  - Serviços de cobrança"
  },
  {
    "value": "118063100",
    "text": "118063100  - Serviços de call center"
  },
  {
    "value": "118063900",
    "text": "118063900  - Serviços de apoio às atividades empresariais por meio de telefone não classificados em subposições anteriores"
  },
  {
    "value": "118064000",
    "text": "118064000  - Serviços combinados de escritório e apoio administrativo"
  },
  {
    "value": "118065100",
    "text": "118065100  - Serviços de fotocópias e outros serviços de reprodução de documentos"
  },
  {
    "value": "118065200",
    "text": "118065200  - Serviços de execução e envio de mala direta e de elaboração de listas de endereços"
  },
  {
    "value": "118065300",
    "text": "118065300  - Serviços de preparação de documentos"
  },
  {
    "value": "118065900",
    "text": "118065900  - Serviços especializados de apoio a escritório não classificados em subposições anteriores"
  },
  {
    "value": "118066100",
    "text": "118066100  - Serviços de assistência e organização de convenções"
  },
  {
    "value": "118066200",
    "text": "118066200  - Serviços de assistência e organização de feiras de negócios"
  },
  {
    "value": "118066300",
    "text": "118066300  - Serviços de assistência e organização de exposições e outros eventos"
  },
  {
    "value": "118067000",
    "text": "118067000  - Serviços de jardinagem"
  },
  {
    "value": "118068100",
    "text": "118068100 - Serviços de agenciamento de modelos"
  },
  {
    "value": "118068200",
    "text": "118068200 - Serviços de agenciamento de artistas"
  },
  {
    "value": "118068300",
    "text": "118068300 - Serviços de agenciamento de atletas"
  },
  {
    "value": "118069000",
    "text": "118069000 - Serviços de apoio não classificados em subposições anteriores"
  },
  {
    "value": "119011000",
    "text": "119011000 - Serviços de apoio à agricultura"
  },
  {
    "value": "119012000",
    "text": "119012000 - Serviços de apoio à pecuária"
  },
  {
    "value": "119013000",
    "text": "119013000 - Serviços de apoio à produção florestal (silvicultura)"
  },
  {
    "value": "119014000",
    "text": "119014000 - Serviços de apoio à pesca"
  },
  {
    "value": "119015000",
    "text": "119015000 - Serviços de apoio à aquicultura"
  },
  {
    "value": "119021000",
    "text": "119021000 - Serviços de apoio à extração de petróleo e gás"
  },
  {
    "value": "119029000",
    "text": "119029000 - Serviços de apoio à mineração não classificados em subposições anteriores"
  },
  {
    "value": "119031100",
    "text": "119031100 - Serviços de apoio à transmissão de eletricidade"
  },
  {
    "value": "119031200",
    "text": "119031200 - Serviços de apoio à distribuição de eletricidade"
  },
  {
    "value": "119032000",
    "text": "119032000 - Serviços de apoio à distribuição de gás por meio de tubulações"
  },
  {
    "value": "119033000",
    "text": "119033000 - Serviços de apoio à distribuição de água por meio de tubulações, exceto vapor de água e água quente"
  },
  {
    "value": "119034000",
    "text": "119034000 - Serviços de apoio a distribuição de vapor de água, água quente e ar condicionado por meio de tubulações"
  },
  {
    "value": "119035000",
    "text": "119035000 - Serviços de apoio à distribuição de água, exceto por meio de tubulações"
  },
  {
    "value": "120011000",
    "text": "120011000 - Serviços de manutenção e reparação de produtos metálicos, exceto maquinários e equipamentos"
  },
  {
    "value": "120012000",
    "text": "120012000 - Serviços de manutenção e reparação de computadores e seus periféricos e de maquinário para escritório"
  },
  {
    "value": "120013110",
    "text": "120013110 - Serviços de manutenção e reparação de veículos rodoviários motorizados"
  },
  {
    "value": "120013120",
    "text": "120013120 - Serviços de manutenção e reparação de veículos rodoviários não motorizados"
  },
  {
    "value": "120013200",
    "text": "120013200 - Serviços de manutenção e reparação de veículos sobre trilhos"
  },
  {
    "value": "120013300",
    "text": "120013300 - Serviços de manutenção e reparação de veículos aquaviários"
  },
  {
    "value": "120013410",
    "text": "120013410 - Serviços de manutenção e reparação de aeronaves, exceto de motores, turborreatores e turbopropulsores aeronáuticos"
  },
  {
    "value": "120013420",
    "text": "120013420 - Serviços de manutenção e reparação de motores, turborreatores e turbopropulsores aeronáuticos"
  },
  {
    "value": "120013430",
    "text": "120013430 - Serviços de manutenção e reparação de foguetes e equipamentos aeroespaciais"
  },
  {
    "value": "120013500",
    "text": "120013500 - Serviços de manutenção e reparação de veículos militares"
  },
  {
    "value": "120013900",
    "text": "120013900 - Serviços de manutenção e reparação de maquinários e equipamentos de transporte não classificados em subposições anteriores"
  },
  {
    "value": "120014000",
    "text": "120014000 - Serviços de manutenção e reparação de plataformas, inclusive navios-plataforma, para extração de petróleo e gás"
  },
  {
    "value": "120015000",
    "text": "120015000 - Serviços de manutenção e reparação de maquinários e equipamentos de uso industrial"
  },
  {
    "value": "120016000",
    "text": "120016000 - Serviços de manutenção e reparação de maquinários e equipamentos de uso comercial"
  },
  {
    "value": "120017000",
    "text": "120017000 - Serviços de manutenção e reparação de equipamentos e aparelhos de telecomunicações"
  },
  {
    "value": "120018100",
    "text": "120018100 - Serviços de manutenção e reparação de aparelhos eletroeletrônicos domésticos"
  },
  {
    "value": "120018200",
    "text": "120018200 - Serviços de manutenção e reparação de instrumentos e equipamentos médico-hospitalares, odontológicos, óticos e de precisão"
  },
  {
    "value": "120018300",
    "text": "120018300 - Serviços de manutenção e reparação de equipamentos militares"
  },
  {
    "value": "120018900",
    "text": "120018900 - Serviços de manutenção e reparação de outros maquinários e equipamentos não classificados em subposições anteriores"
  },
  {
    "value": "120021000",
    "text": "120021000 - Serviços de manutenção e reparação de produtos de couro, calçados, malas e bolsas"
  },
  {
    "value": "120022000",
    "text": "120022000 - Serviços de manutenção e reparação de relógios e joias"
  },
  {
    "value": "120023000",
    "text": "120023000 - Serviços de manutenção e reparação de móveis"
  },
  {
    "value": "120024000",
    "text": "120024000 - Serviços de manutenção de roupas e outros produtos têxteis"
  },
  {
    "value": "120029000",
    "text": "120029000 - Serviços de manutenção e reparação de outros bens de consumo não classificados em subposições anteriores"
  },
  {
    "value": "120031000",
    "text": "120031000 - Serviços de instalação de produtos metálicos, exceto maquinário e equipamentos"
  },
  {
    "value": "120032110",
    "text": "120032110 - Serviços de montagem sob encomenda de turbinas industriais"
  },
  {
    "value": "120032190",
    "text": "120032190 - Serviços de instalação de maquinários, aparelhos e equipamentos industriais não classificados em itens anteriores"
  },
  {
    "value": "120032200",
    "text": "120032200 - Serviços de instalação de computadores e seus periféricos e maquinário de escritório"
  },
  {
    "value": "120032300",
    "text": "120032300 - Serviços de instalação de equipamentos e aparelhos de comunicação, incluindo de rádio e de televisão"
  },
  {
    "value": "120032400",
    "text": "120032400 - Serviços de instalação de maquinários, equipamentos, instrumentos e aparelhos médico-hospitalares, óticos e de precisão"
  },
  {
    "value": "120032510",
    "text": "120032510 - Serviços de instalação de sensores e sistemas de armas"
  },
  {
    "value": "120032520",
    "text": "120032520 - Serviços de instalação de maquinários, aparelhos e equipamentos de emprego militar"
  },
  {
    "value": "120032610",
    "text": "120032610 - Serviços de montagem sob encomenda de motores, turborreatores e turbopropulsores aeronáuticos"
  },
  {
    "value": "120032690",
    "text": "120032690 - Serviços de instalação de maquinários e equipamentos de transporte não classificados em itens anteriores"
  },
  {
    "value": "120032900",
    "text": "120032900 - Serviços de instalação de maquinários, aparelhos e equipamentos não classificados em subposições anteriores"
  },
  {
    "value": "121011000",
    "text": "121011000 - Serviços de editoração"
  },
  {
    "value": "121012100",
    "text": "121012100 - Serviços de impressão"
  },
  {
    "value": "121012200",
    "text": "121012200 - Serviços relacionados à impressão"
  },
  {
    "value": "121012300",
    "text": "121012300 - Serviços de reprodução de mídia gravada"
  },
  {
    "value": "121013000",
    "text": "121013000  - Serviços de publicação"
  },
  {
    "value": "122011100",
    "text": "122011100 - Serviços de creches ou de entidade equivalente"
  },
  {
    "value": "122011200",
    "text": "122011200 - Serviços de pré-escola"
  },
  {
    "value": "122011900",
    "text": "122011900 - Serviços de educação infantil não classificados em subposições anteriores"
  },
  {
    "value": "122012000",
    "text": "122012000 - Serviços de ensino fundamental"
  },
  {
    "value": "122013000",
    "text": "122013000 - Serviços de ensino médio"
  },
  {
    "value": "122020000",
    "text": "122020000 - Serviços de educação técnica de nível médio"
  },
  {
    "value": "122031000",
    "text": "122031000 - Serviços de ensino fundamental de jovens e adultos"
  },
  {
    "value": "122032000",
    "text": "122032000 - Serviços de ensino médio de jovens e adultos"
  },
  {
    "value": "122041000",
    "text": "122041000 - Serviços educacionais de graduação"
  },
  {
    "value": "122042000",
    "text": "122042000 - Serviços educacionais de pós-graduação"
  },
  {
    "value": "122043000",
    "text": "122043000 - Serviços educacionais de extensão"
  },
  {
    "value": "122044000",
    "text": "122044000 - Serviços educacionais de cursos sequenciais"
  },
  {
    "value": "122051100",
    "text": "122051100 - Serviços de educação com enfoque cultural"
  },
  {
    "value": "122051200",
    "text": "122051200 - Serviços de educação desportiva e recreacional"
  },
  {
    "value": "122051300",
    "text": "122051300 - Serviços de educação em línguas estrangeiras e de sinais"
  },
  {
    "value": "122051400",
    "text": "122051400 - Serviços de palestras e conferências"
  },
  {
    "value": "122051900",
    "text": "122051900 - Outros serviços de educação, inclusive treinamento, não classificados em subposições anteriores"
  },
  {
    "value": "122052000",
    "text": "122052000 - Serviços de apoio aos serviços educacionais"
  },
  {
    "value": "123011100",
    "text": "123011100 - Serviços cirúrgicos"
  },
  {
    "value": "123011200",
    "text": "123011200 - Serviços ginecológicos e obstétricos"
  },
  {
    "value": "123011300",
    "text": "123011300 - Serviços psiquiátricos"
  },
  {
    "value": "123011400",
    "text": "123011400 - Serviços prestados em Unidades de Terapia Intensiva"
  },
  {
    "value": "123011500",
    "text": "123011500 - Serviços de atendimento de urgência"
  },
  {
    "value": "123011900",
    "text": "123011900 - Serviços hospitalares não classificados em subposições anteriores"
  },
  {
    "value": "123012100",
    "text": "123012100 - Serviços de clínica médica"
  },
  {
    "value": "123012200",
    "text": "123012200 - Serviços médicos especializados"
  },
  {
    "value": "123012300",
    "text": "123012300 - Serviços odontológicos"
  },
  {
    "value": "123019100",
    "text": "123019100 - Serviços de enfermagem"
  },
  {
    "value": "123019200",
    "text": "123019200 - Serviços de fisioterapia"
  },
  {
    "value": "123019300",
    "text": "123019300 - Serviços laboratoriais"
  },
  {
    "value": "123019400",
    "text": "123019400 - Serviços de diagnóstico por imagem"
  },
  {
    "value": "123019500",
    "text": "123019500 - Serviços de bancos de material biológico humano"
  },
  {
    "value": "123019600",
    "text": "123019600 - Serviços de ambulância"
  },
  {
    "value": "123019700",
    "text": "123019700 - Serviços de assistência ao parto e pós-parto"
  },
  {
    "value": "123019800",
    "text": "123019800 - Serviços de psicologia"
  },
  {
    "value": "123019900",
    "text": "123019900 - Outros serviços de saúde humana não classificados em subposições anteriores"
  },
  {
    "value": "123021000",
    "text": "123021000 - Serviços de cuidado em saúde em unidades de acolhimento"
  },
  {
    "value": "123022100",
    "text": "123022100 - Serviços de assistência a idosos em unidades de acolhimento"
  },
  {
    "value": "123022200",
    "text": "123022200 - Serviços de assistência a crianças e adolescentes com deficiência em unidades de acolhimento"
  },
  {
    "value": "123022300",
    "text": "123022300 - Serviços de assistência a adultos com deficiência em unidades de acolhimento"
  },
  {
    "value": "123030000",
    "text": "123030000 - Serviços de assistência prestados a pessoas em situação de vulnerabilidade social com acomodação"
  },
  {
    "value": "123041100",
    "text": "123041100 - Serviços de reabilitação vocacional para pessoas com deficiência"
  },
  {
    "value": "123041200",
    "text": "123041200 - Serviços de reabilitação vocacional para desempregados"
  },
  {
    "value": "123041900",
    "text": "123041900 - Serviço de reabilitação vocacional não classificados nas subposições anteriores"
  },
  {
    "value": "123042000",
    "text": "123042000 - Serviços de orientação e aconselhamento relacionados a crianças e adolescentes"
  },
  {
    "value": "123049000",
    "text": "123049000 - Serviços de assistência social sem acomodação não classificados em subposições anteriores"
  },
  {
    "value": "124010000",
    "text": "124010000  - Serviços de tratamento de água"
  },
  {
    "value": "124021000",
    "text": "124021000  - Serviços de esgoto e tratamento de esgotos"
  },
  {
    "value": "124022000",
    "text": "124022000  - Serviços de esvaziamento e limpeza de fossas sépticas"
  },
  {
    "value": "124031100",
    "text": "124031100  - Serviços de coleta de resíduos de serviços de saúde e outros resíduos biológicos"
  },
  {
    "value": "124031200",
    "text": "124031200  - Serviços de coleta de resíduos perigosos industriais, exceto resíduos de serviços de saúde e outros resíduos biológicos"
  },
  {
    "value": "124031900",
    "text": "124031900 - Serviços de coleta de outros resíduos perigosos não classificados em subposições anteriores"
  },
  {
    "value": "124032100",
    "text": "124032100 - Serviços de coleta de resíduos recicláveis, não perigosos, de origem doméstica"
  },
  {
    "value": "124032200",
    "text": "124032200 - Serviços de coleta de resíduos recicláveis, não perigosos, exceto de origem doméstica"
  },
  {
    "value": "124033100",
    "text": "124033100 - Serviços de coleta de resíduos gerais de origem doméstica"
  },
  {
    "value": "124033200",
    "text": "124033200 - Serviços de coleta de resíduos gerais, exceto de origem doméstica"
  },
  {
    "value": "124041100",
    "text": "124041100 - Serviços de triagem, preparação, consolidação e estocagem de resíduos perigosos"
  },
  {
    "value": "124041200",
    "text": "124041200 - Serviços de demolição e desmantelamento de embarcações, veículos e outros bens"
  },
  {
    "value": "124041300",
    "text": "124041300 - Serviços de triagem, preparação, consolidação e estocagem de resíduos recicláveis não perigosos"
  },
  {
    "value": "124041900",
    "text": "124041900 - Serviços de triagem, preparação, consolidação e estocagem de resíduos não perigosos, exceto os recicláveis"
  },
  {
    "value": "124042100",
    "text": "124042100 - Serviços de tratamento de resíduos perigosos"
  },
  {
    "value": "124042200",
    "text": "124042200 - Serviços de eliminação de resíduos perigosos"
  },
  {
    "value": "124043100",
    "text": "124043100 - Serviços de tratamento e eliminação de resíduos não perigosos em aterros sanitários"
  },
  {
    "value": "124043200",
    "text": "124043200 - Serviços de tratamento e eliminação de resíduos não perigosos em aterros, exceto os sanitários"
  },
  {
    "value": "124043300",
    "text": "124043300 - Serviços de incineração de resíduos não perigosos"
  },
  {
    "value": "124043900",
    "text": "124043900 - Serviços de tratamento e eliminação de resíduos não perigosos não classificados em subposições anteriores"
  },
  {
    "value": "124051100",
    "text": "124051100  - Serviços de remediação e limpeza do ar"
  },
  {
    "value": "124051200",
    "text": "124051200  - Serviços de remediação e limpeza de águas de superfície"
  },
  {
    "value": "124051300",
    "text": "124051300  - Serviços de remediação e limpeza do solo e de águas subterrâneas"
  },
  {
    "value": "124051400",
    "text": "124051400 - Serviços de remediação em edificações"
  },
  {
    "value": "124052000",
    "text": "124052000  - Serviços de contenção, controle e monitoramento de áreas contaminadas"
  },
  {
    "value": "124059000",
    "text": "124059000 - Serviços de remediação não classificados em subposições anteriores"
  },
  {
    "value": "124061000",
    "text": "124061000 - Serviços de varrição de vias e áreas públicas"
  },
  {
    "value": "124069000",
    "text": "124069000 - Serviços de limpeza urbana e similares não classificados em subposições anteriores"
  },
  {
    "value": "124070000",
    "text": "124070000 - Serviços de proteção ambiental não classificados em posições anteriores"
  },
  {
    "value": "125011100",
    "text": "125011100 - Serviços de gravação de som em estúdio"
  },
  {
    "value": "125011200",
    "text": "125011200 - Serviços de gravação de som ao vivo"
  },
  {
    "value": "125012100",
    "text": "125012100 - Serviços de produção de programas de televisão, videoteipes e filmes"
  },
  {
    "value": "125012200",
    "text": "125012200 - Serviços de produção de programas de rádio"
  },
  {
    "value": "125013100",
    "text": "125013100 - Serviços de edição de obras audiovisuais"
  },
  {
    "value": "125013200",
    "text": "125013200 - Serviços de duplicação e transferência de obras audiovisuais"
  },
  {
    "value": "125013300",
    "text": "125013300 - Serviços de correção de cor e restauração digital de obras audiovisuais"
  },
  {
    "value": "125013400",
    "text": "125013400 - Serviços de efeitos visuais em obras audiovisuais"
  },
  {
    "value": "125013500",
    "text": "125013500 - Serviços de animação"
  },
  {
    "value": "125013600",
    "text": "125013600 - Serviços de legendas, títulos e dublagem em obras audiovisuais"
  },
  {
    "value": "125013700",
    "text": "125013700 - Serviços de projeto e edição de som em obras audiovisuais"
  },
  {
    "value": "125013900",
    "text": "125013900 - Serviços de pós-produção de obras audiovisuais não classificados em subposições anteriores"
  },
  {
    "value": "125014000",
    "text": "125014000 - Serviços de agenciamento para a comercialização de obras audiovisuais"
  },
  {
    "value": "125015000",
    "text": "125015000 - Serviços de projeção de filmes"
  },
  {
    "value": "125019000",
    "text": "125019000 - Serviços de produção audiovisual, de apoio e relacionados não classificados em subposições anteriores"
  },
  {
    "value": "125021000",
    "text": "125021000 - Serviços de organização e promoção de atuações artísticas ao vivo"
  },
  {
    "value": "125022000",
    "text": "125022000 - Serviços de produção e apresentação de atuações artísticas ao vivo"
  },
  {
    "value": "125023000",
    "text": "125023000 - Serviços de apoio para atuações artísticas ao vivo"
  },
  {
    "value": "125029000",
    "text": "125029000 - Serviços de apresentação e promoção de atuações artísticas e outros serviços de entretenimento ao vivo não classificados em subposições anteriores"
  },
  {
    "value": "125031000",
    "text": "125031000 - Serviços de atuação artística"
  },
  {
    "value": "125032000",
    "text": "125032000 - Serviços de autores, compositores, escultores, pintores e outros artistas, exceto os de atuação artística"
  },
  {
    "value": "125041100",
    "text": "125041100 - Serviços de museus"
  },
  {
    "value": "125041200",
    "text": "125041200 - Serviços de preservação e operação de locais e construções históricas"
  },
  {
    "value": "125042100",
    "text": "125042100 - Serviços de jardins botânico e zoológico"
  },
  {
    "value": "125042200",
    "text": "125042200 - Serviços de reserva natural, incluindo preservação de vida selvagem"
  },
  {
    "value": "125051000",
    "text": "125051000 - Serviços de organização e promoção de eventos desportivos e recreacionais desportivos"
  },
  {
    "value": "125052000",
    "text": "125052000 - Serviços de clubes desportivos"
  },
  {
    "value": "125059000",
    "text": "125059000 - Serviços desportivos e recreacionais desportivos não classificados em subposições anteriores"
  },
  {
    "value": "125060000",
    "text": "125060000 - Serviços fornecidos por atletas e desportistas, por conta própria, e serviços de apoio relacionados com desportes e recreação desportiva"
  },
  {
    "value": "125071000",
    "text": "125071000 - Serviços de parques temáticos de diversão"
  },
  {
    "value": "125079000",
    "text": "125079000 - Serviços de parques de diversão e atrações similares não classificados em subposições anteriores"
  },
  {
    "value": "125080000",
    "text": "125080000 - Serviços recreativos, culturais e desportivos não classificados em posições anteriores"
  },
  {
    "value": "126011000",
    "text": "126011000 - Serviços de limpeza de têxteis, exceto quando realizados a seco"
  },
  {
    "value": "126012000",
    "text": "126012000 - Serviços de limpeza a seco"
  },
  {
    "value": "126013000",
    "text": "126013000 - Serviços de tinturaria"
  },
  {
    "value": "126014000",
    "text": "126014000 - Serviços de passadoria de roupas e outros artigos têxteis"
  },
  {
    "value": "126019000",
    "text": "126019000 - Serviços de lavanderia não classificados em subposições anteriores"
  },
  {
    "value": "126021000",
    "text": "126021000 - Serviços de cabeleireiros e barbeiros"
  },
  {
    "value": "126022000",
    "text": "126022000 - Serviços de manicure, pedicure e tratamento cosmético"
  },
  {
    "value": "126023000",
    "text": "126023000 - Serviços de bem-estar físico"
  },
  {
    "value": "126029000",
    "text": "126029000 - Serviços de tratamento de beleza e bem-estar físico não classificados em subposições anteriores"
  },
  {
    "value": "126030000",
    "text": "126030000 - Serviços funerários, de cremação e de embalsamamento"
  },
  {
    "value": "126040000",
    "text": "126040000 - Serviços de confecção de roupas e outros artigos têxteis"
  },
  {
    "value": "126050000",
    "text": "126050000 - Serviços domésticos"
  },
  {
    "value": "126060000",
    "text": "126060000 - Serviços pessoais não classificados em posições anteriores"
  }
];
export { pagamento, formaPagamento, tipoArquivo, defaultUserPermission, defaultAdmPermission, defaultWorkingSchedule, cfop, ufs, nfseSituationsNfse, productionOrderSituations, typesInstallment, departaments, resumeTypes, typesKeyPix, decimalPlacesOptions, unidade, genero, TypePaymentsForCombobox, codesService, codesNbs }
